<template>
  <!--活动部件-小 -->
  <div class="createPlayStep new-input-box">
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="clickLocalStep()"
        >返回</jd-button
      >
      <span class="backBox_name"
        >BI店铺礼包</span
      >
    </div>
    <!--  活动条件表单部分 -->
    <div v-loading="fromLoading" class="secondstep">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="backgroundForm"
        label-width="160px"
        :disabled="backgroundOpacity"
      >
        <jd-title
          label="基本信息"
          type="bold"
          style="margin-top: 0px; margin-left: 20px"
        ></jd-title>
        <el-form-item label="活动名称:" required>
          <el-input
            v-model="ruleForm.activityName"
            maxlength="15"
            show-word-limit
            placeholder="请填入"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间:" required>
          <div class="my_select_time">
            <el-date-picker
              v-model="activityTimeValue[0]"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :picker-options="pickerOptionsValue1"
              :default-time="defaultTime[0]"
              @change="activityTimeChange"
              :disabled="$route.query.valueRow && !isSave && !isCopy"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <span style="margin: 0 10px">-</span>
            <el-date-picker
              v-model="activityTimeValue[1]"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsValue2"
              @change="activityTimeChange"
              :default-time="defaultTime[1]"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
          <span class="lastTime" style="color: #666">
            活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
            <span style="color: #fe4d45">{{ timeOut }}</span> 小时
            <el-tooltip
              class="item"
              effect="light"
              content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
              placement="bottom"
            >
              <el-button type="text" style="width: 35px">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </span>
        </el-form-item>
        <jd-title
          label="活动设置"
          type="bold"
          style="margin-left: 20px"
        ></jd-title>
        <div class="new-input-box">
          <el-form-item label="发送人数:" required style="margin-bottom: 15px;margin-top:15px;">
            <el-input 
              v-model="sendNum" 
              placeholder="请输入正整数"
              style="width: 150px;"
              :disabled="backgroundOpacity"
              @input="handleSendNumInput"
            ></el-input>
            <el-tooltip 
              placement="top" 
              content="弹窗默认需要发放1积分，可设置发放的人数上限"
              effect="dark"
              style="margin-left: 8px;"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            <el-checkbox 
              v-model="autoEndActivity" 
              :disabled="backgroundOpacity"
              style="margin-left: 10px;"
            >勾选奖品发送完成自动结束活动</el-checkbox>
          </el-form-item>
          <el-form-item label="投放人群:" required>
            <el-radio-group v-model="deliveryCrowdType" :disabled="backgroundOpacity">
              <el-radio :label="1">关联活动</el-radio>
              <el-radio :label="2">自定义人群</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="弹窗设置:" required>
          <jd-button
            type="blue"
            @click="addCardFace"
            :disabled="backgroundOpacity"
            >+添加弹窗 ({{ cardFaces.length}}/20)</jd-button
          >
          <span style="margin-left: 10px"
            >注意：该弹窗顺序为优先级顺序，数字越小优先级越高；当用户符合多个活动时，弹窗展示优先级最高的活动内容，当无符合用户参与的活动时则不弹弹窗。</span
          >
        </el-form-item>

        <el-tabs
          v-model="activeCardTab"
          closable
          @tab-remove="removeCardFace"
          @tab-click="handleCardTabClick"
          v-if="cardFaces.length > 0"
          style="margin-left: 80px"
        >
          <el-tab-pane
            v-for="(cardFace, index) in cardFaces"
            :key="cardFace.id"
            :label="index === cardFaces.length - 1 ? '兜底弹窗' : `弹窗${index + 1}`"
            :name="cardFace.id"
          >
            <div class="cardSet">
              <!-- 原有的表单内容 -->
              <div class="form-content">
                <!-- 关联活动条件 - 只在非兜底页显示 -->
                <el-form-item v-if="index !== cardFaces.length - 1 && deliveryCrowdType === 1" label="关联活动:" required>
                  <jd-button
                    type="blue"
                    @click="selectActivity(index)"
                    :disabled="backgroundOpacity"
                    >+选择活动</jd-button
                  >
                  <div class="activityDetail" v-if="cardFace.activityInfo">
                    <span
                      >活动名称:
                      {{ cardFace.activityInfo.activityName || "-" }}</span
                    >
                    <span
                      >活动类型:
                      {{ cardFace.activityInfo.subTypeStr || "-" }}</span
                    >
                    <span
                      >投放渠道:
                      {{ cardFace.activityInfo.sellerLinkName || "-" }}</span
                    >
                    <span
                      >活动时间: {{ cardFace.activityInfo.startTime || "" }} -
                      {{ cardFace.activityInfo.endTime || "" }}</span
                    >
                  </div>
                </el-form-item>

                <!-- 活动对象 -->
                 <el-form-item v-if="index !== cardFaces.length - 1 && deliveryCrowdType === 2"  required>
                  <div style="margin-left:-140px">
                    <informationForm
                       @selectPeopleSure="selectPeopleSure" 
                      :defaultActMember.sync="cardFace.ruleForm.actMember"
                       ref="informationForm" 
                        v-model="cardFace.ruleForm"
                       :needNonMember="true" 
                       :isNeedCusType="true"
                       :isShowCondFollow = 'false'
                       :plusObject.sync="cardFace.ruleForm.ruleDTO.plusObject"
                       :isCheckOpenCardTime.sync="cardFace.ruleForm.ruleDTO.isCheckOpenCardTime"
                       :openCardStartTime.sync="cardFace.ruleForm.ruleDTO.openCardStartTime"
                       :openCardEndTime.sync="cardFace.ruleForm.ruleDTO.openCardEndTime"
                       :cusType.sync="cardFace.ruleForm.ruleDTO.cusType" 
                       :peopleSelected.sync="cardFace.ruleForm.peopleSelected"
                       :basicInformation = 'false'
                       :activityId="63"
                       :disabled="backgroundOpacity"
                       :isShowCrowdTips="false"
                       >

                    </informationForm>

                  <!-- 加购人群 -->
                 <div style="text-align: left;margin-left:142px" v-if="cardFace.ruleForm.actMember == 2" >
                   <div  class="condition-header">
                      <span class="condition-title">加购人群</span>
                      <jd-button type="blueText" class="toggle-btn" @click="isShopConditionExpandedOne = !isShopConditionExpandedOne">
                        {{ isShopConditionExpandedOne ? "收起" : "展开" }}
                      </jd-button>
                  </div>
                  <div class="cart-add-condition" style="margin-left: 30px;" v-if="isShopConditionExpandedOne">
                    <div  class="cart-add-detail">
                        <el-checkbox label="加入购物车满" v-model="cardFace.ruleForm.isOpenShoppingConditions">
                            <span>加入购物车满</span>
                               <el-select 
                                      size="small" style="width: 100px; margin: 0 10px;" 
                                      v-model="cardFace.ruleForm.cartFullDays"
                                      :disabled="!cardFace.ruleForm.isOpenShoppingConditions"
                                      placeholder="请选择">
                                      <el-option v-for="item in sex_all"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"></el-option>
                                  </el-select>
                        </el-checkbox>
                        <span>天且90天未购的人群</span>
                        <div class="cart-add-goods">
                            <span>加购商品：</span>
                            <jd-button type="primary" size="small" @click="isChange">选择商品 ({{ cardFace.ruleForm.skuList.length }}/100)</jd-button>
                        </div>
                     </div>
                    </div>
                   </div>
                  </div>
                  
                </el-form-item>
                
                <!-- 兜底页活动对象标识 -->
                <el-form-item v-if="index === cardFaces.length - 1" label="活动对象:" required>
                  <div style="border-radius: 4px; display: inline-block;">
                    <span style="font-weight: 500; color: #333;">兜底人群</span>
                    <el-tooltip placement="top" content="即用户不符合所设置的弹窗的对象时就弹此兜底弹窗">
                      <i class="el-icon-question" style="margin-left: 5px; color: #999; cursor: help;"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>

                <el-form-item label="弹窗模板:" required>
                  <el-radio
                    @change="handleTemplateTypeChange(index, $event)"
                    v-model="cardFace.templateType"
                    :label="0"
                  >
                    系统模板
                  </el-radio>
                  <el-radio
                    @change="handleTemplateTypeChange(index, $event)"
                    v-model="cardFace.templateType"
                    :label="1"
                  >
                    自定义模板
                  </el-radio>
                  <div>
                    <div
                      class="template-tabs"
                      v-if="cardFace.templateType == 0"
                    >
                      <!-- active: cardFace.activeTabIndex == tabIndex, -->
                      <div
                        v-for="(tab, tabIndex) in templateTabs"
                        :key="tabIndex"
                        class="tab-item"
                        :class="{
                          active: cardFace.activeTabId == tab.id,
                          first: tabIndex === 0,
                          last: tabIndex === templateTabs.length - 1,
                        }"
                        @click="handleTabClick(tab.id, index)"
                      >
                        {{ tab.name }}
                      </div>
                    </div>
                    <div v-if="cardFace.templateType == 1">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => onBeforeUpload2(file, index)"
                        :on-success="(res) => onUploadSuccess2(res, index)"
                        :disabled="backgroundOpacity"
                      >
                        <jd-button type="blue" :disabled="backgroundOpacity"
                          >上传图片</jd-button
                        >
                      </el-upload>
                      <span class="ml10 c_999" v-if="activityDataID == 56"
                        >格式：jpg、png、gif，尺寸：宽630px * 高788px</span
                      >
                      <span class="ml10 c_999" v-else>
                        格式：jpg、png、gif，尺寸：宽630px * 高788px
                      </span>
                    </div>
                    <!-- 选择模板 -->
                    <div
                      class="template-container"
                      v-if="cardFace.templateType == 0"
                    >
                      <div
                        class="template-item"
                        v-for="(item, templateIndex) in templateList"
                        :key="item.id"
                        @click="
                          selectTemplate(index, templateIndex, item.id, item)
                        "
                      >
                        <img :src="item.templateUrl" class="template-image" />
                        <div class="template-name">
                          {{ item.templateName }}
                        </div>
                        <img
                          v-if="cardFace.templateId == item.id"
                          class="template-selected-icon"
                          src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"
                        />
                      </div>
                    </div>
                    <!-- 自定义模板列表展示 -->
                    <div
                      class="template-container"
                      v-if="cardFace.templateType == 1"
                    >
                      <div
                        class="template-item"
                        v-for="(item, templateIndex) in customTemplateList"
                        :key="item.id || templateIndex"
                        @click="
                          selectCustomTemplate(index, templateIndex, item)
                        "
                      >
                        <div class="template-item-wrapper">
                          <img :src="item.imageUrl" class="template-image" />
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                            class="delectIcom"
                            @click.stop="deleteCustomTemplate(item.id)"
                          />
                        </div>
                        <div class="template-name">
                          {{ item.imageName }}
                        </div>
                        <img
                          v-if="cardFace.cusTemplateJSON == item.imageUrl"
                          class="template-selected-icon"
                          src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"
                        />
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <!-- 跳转链接 - 在兜底页或选择自定义人群时显示 -->
                <el-form-item v-if="index == cardFaces.length - 1 || (index !== cardFaces.length - 1 && deliveryCrowdType == 2)" label="跳转链接:" label-width="150px" required>
                  <el-input
                    v-model="cardFace.jumpUrl"
                    placeholder="仅支持填写京东域内链接"
                    style="width: 350px"
                    @input="syncJumpLink(cardFace)"
                  ></el-input>&nbsp;
                  <jd-button type="blue" @click="setOpenUrl(cardFace)" v-preventReClick :disabled="backgroundOpacity" >入会链接</jd-button>
                </el-form-item>
                
              </div>

              <!-- 预览图容器移到右侧 -->
              <div class="preview-image-wrapper">
                <img
                  :src="previewImageSrc"
                  alt="预览图"
                  class="preview-image"
                />
                <img
                  class="previewBg"
                  v-if="
                    activityDataID == 63
                  "
                  :src="cardFace.imageUrl"
                />
                <!-- <img
                  class="previewBg2"
                  v-if="
                    cardFace.previewData.prizeSettingType !== 0 &&
                    cardFace.previewData.prizeSettingType !== 1 &&
                    activityDataID == 57
                  "
                  :src="cardFace.imageUrl"
                /> -->
                <div class="previewTip">
                  图为预览效果,以实际投放位置效果为准
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- 新增字段 -->
        <el-form-item label="是否重点活动:" required>
          <div class="flexc-cen-x mt10">
            <el-radio-group v-model="isKeyActivity" :disabled="activityData.status&&!activityData.isCopy">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            <el-tooltip class="item" effect="dark" placement="top">
              <template slot="content">
                <div>
                  大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                </div>
              </template>
              <i class="new-icon-box ml8"></i>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="活动投放位置:" required>
          <el-checkbox-group v-model="placementPosition" :disabled="activityData.status&&!activityData.isCopy">
            <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
            <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
            <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
            <el-checkbox label="SHOP">店铺</el-checkbox>
            <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
            <el-checkbox label="OTHER">其他渠道</el-checkbox>
            <el-tooltip class="item" effect="dark" placement="top">
              <template slot="content">
                <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
              </template>
              <i class="new-icon-box ml8"></i>
            </el-tooltip>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="兜底卡面:" required>
          <div class="upload-template">
            <div class="upload-actions">
              <el-upload
                class="upload"
                action="/jd-hd-web/image/upload"
                :show-file-list="false"
                :before-upload="onBeforeUpload"
                :on-success="onUploadSuccess"
                :disabled="backgroundOpacity"
              >
                <jd-button type="blue" :disabled="backgroundOpacity"
                  >上传图片</jd-button
                >
              </el-upload>
              <jd-button
                type="blueText"
                class="ml10"
                :disabled="backgroundOpacity"
                @click="onTemplateReset"
                >重置</jd-button
              >
              <el-tooltip class="item" effect="light" placement="bottom">
                <div slot="content">
                  当卡面设置规则为【千人千面】或者【活动结束不展示卡面】时，C端可能出现无内容展示的情况，所以默认会设置兜底卡面图，正常情况下不会展示该兜底卡面图
                </div>
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question c_999"></i>
                </el-button>
              </el-tooltip>
            </div>
            <span class="ml10 c_999" v-if="activityDataID == 56"
              >格式：jpg、png、gif，尺寸：宽710px * 高355px</span
            >
            <span class="ml10 c_999" v-else>
              格式：jpg、png、gif，尺寸：宽710px * 高710px
            </span>
            <div class="template-preview">
              <el-image
                class="template-image"
                :src="ruleForm.defaultCardUrl"
                fit="contain"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-plus"></i>
                </div>
              </el-image>
            </div>
          </div>
          <el-form-item label="跳转链接:" label-width="75px">
            <el-input
              v-model="ruleForm.jumpUrl"
              placeholder="仅支持填写京东域内链接"
              style="width: 350px"
            ></el-input>
          </el-form-item>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="create_bottom">
      <jd-button style="margin-right: 8px" @click="clickLocalStep()">
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
       <jd-button style="margin-right: 8px" v-if="hasDraftBtn" @click="saveDraft"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button type="break" @click="preSave" v-preventReClick
          >保存并完成设置</jd-button
        >
        <el-popover
          v-if="false"
          placement="top-start"
          width="300"
          trigger="hover"
          content="因官方改造，小部件功能下架，如需实现类似功能可联系客服了解店铺装修定制业务~"
        >
          <jd-button type="disabledGrey" slot="reference" disabled
            >保存并完成设置</jd-button
          >
        </el-popover>
      </template>
    </div>
    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false" style="margin-right: 8px"
          >取消</jd-button
        >
        <jd-button @click="handleDialogCloseAnoth()" type="blue"
          >确定</jd-button
        >
      </div>
    </el-dialog>
    <selectActivityDialog
      :isShow="showSelectActivity"
      :activityIds="63"
      @selectActivity="handlerSelectActivity"
      @close="handleSelectActivityClose"
    />
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList"
      @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
     <!-- 选择商品弹窗 -->
    <select-goods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      :selectGoods="skuList"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
  </div>
</template>

<script>
import {
  createBiStoreGift,
  getBiStoreGiftDetail,
  getSystemTemplateGroup,
  purchaseActivityDetail,
  fullGiftDetail,
  sellerImage,
  orderRankDetail,
  getGiftBagTemplate,
  getGiftBagList,
  editBiStoreGift
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import selectActivityDialog from "@/views/interactiveMarketing/cardManage/components/selectActivity.vue";
import previewCard1 from "@/views/interactiveMarketing/cardManage/components/previewCard1.vue";
import previewCard2 from "@/views/interactiveMarketing/cardManage/components/previewCard2.vue";
import previewCard3 from "@/views/interactiveMarketing/cardManage/components/previewCard3.vue";
import previewCard4 from "@/views/interactiveMarketing/cardManage/components/previewCard4.vue";
import { getSkuList } from "@/api/member/pointsManagement.js";
import informationForm from "./components/informationForm.vue"
import selectPeople from "@/components/select-people-yunqi.vue";
import selectGoods from "@/components/selectGoodsMonitor2";
import {
  uploadImage,
  addImage,
  getList,
  delImage,
} from "@/api/jhk/sellerImageController.js";
import { measureUnitPage } from "@/api/measuringUnit";

export default {
  components: {
    selectActivityDialog,
    previewCard1,
    previewCard2,
    previewCard3,
    previewCard4,
    informationForm,
    selectPeople,
    selectGoods
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
    activityDataInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    pickerOptionsValue1() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[1]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiresIn
                ).valueOf() ||
              time.getTime() > new Date(that.activityTimeValue[1]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
            );
          }
        },
      };
    },
    pickerOptionsValue2() {
      const that = this;
      return {
        disabledDate: (time) => {
          if (that.activityTimeValue[0]) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(
                  this.$store.getters.loginUserInfo.expiresIn
                ).valueOf() ||
              time.getTime() < new Date(that.activityTimeValue[0]).getTime()
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
            );
          }
        },
      };
    },
    timeDay() {
      if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
        return 0;
      }
      const startTime = new Date(this.activityTimeValue[0]);
      const endTime = new Date(this.activityTimeValue[1]);
      return Math.floor(Math.abs(endTime - startTime) / (1000 * 60 * 60 * 24));
    },
    timeOut() {
      if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
        return 0;
      }
      const startTime = new Date(this.activityTimeValue[0]);
      const endTime = new Date(this.activityTimeValue[1]);
      const timeDiff = endTime.getTime() - startTime.getTime();
      const remainHours = timeDiff % (24 * 3600 * 1000);
      return Math.floor(remainHours / (3600 * 1000));
    },
    activityType() {
      return this.$route.query.valueRow
        ? parseInt(this.$route.query.valueRow)
        : null;
    },
    // 返回当前选中卡面的预览图片
    previewImageSrc() {
      // 获取当前激活的卡面
      const currentCardFace = this.cardFaces.find(
        (face) => face.id === this.activeCardTab
      );
      
      // 如果卡面存在且有图片URL，则返回该图片
      if (currentCardFace && currentCardFace.imageUrl) {
        return currentCardFace.imageUrl;
      }
      
      // 否则返回默认图片
      // const imageName =
      //   this.activityDataID == 57 ? "bigPart.png" : "smallPart.png";
      // return require(`@/assets/images/${imageName}`);
    },
    unitName() {
      if (this.unitList.length > 0) {
        const item = this.unitList.find((v) => v.id == this.measureUnitId);
        if (item) {
          return item.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
  },
  watch: {
    cardFaces: {
      handler(newVal, oldVal) {
        console.log("🚀 ~ newVal:", newVal)
        // 深度监听
      },
      deep: true
    }
  },
  data() {
    return {
      isKeyActivity: 0, //是否重点活动
      placementPosition: [], //活动投放位置
      skuList:[],
      isShowGoods:false,
      sex_all:[
           {
              value: '1',
              label: '1'
            },
            {
              value: '2',
              label: '2'
            },
            {
               value: '3',
               label: '3'
            },
      ],
      xcxUrl: '',
      selectPeopleShow: false, // 控制人群选择弹窗显示
      templateTabs: [],
      peopleList: [],
      // 模板相关数据
      templateList: [],
      templateCache: new Map(),
      selectedTemplateId: null, // 当前选中的模板ID
      // 卡面相关数据
      cardFaces: [
        {
          id: "card_0",
          title: "",
          topic: "",
          description: "",
          isShowParticipateNum: 1, // 是否展示参与人数 0-否 1-是
          isShowActivityItem: 0, // 是否展示活动商品 0-否 1-是
          templateType: 0, // 0: 系统模板, 1: 自定义模板
          cusTemplateJSON: "", // 自定义模板
          templateId: "", // 模板ID
          imageUrl: "", // 模板图片
          activeTabIndex: 0,
          activeTabId: "",
          activityInfo: {}, // 关联的活动信息
          previewData: {}, // 预览数据
             ruleForm: {
              skuList: [], // 商品列表
              actMember: "1", // 活动对象类型
        // 设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        isOpenShoppingConditions:false,
        cartFullDays:1,
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
      },
        },
        {
          id: "card_1",
          title: "兜底页",
          topic: "",
          description: "",
          isShowParticipateNum: 1,
          isShowActivityItem: 0,
          templateType: 0,
          cusTemplateJSON: "",
          templateId: "",
          imageUrl: "",
          activeTabIndex: 0,
          activeTabId: "",
          activityInfo: {},
          previewData: {},
          jumpUrl: "", // 跳转链接作为顶层属性
            ruleForm: {
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
        }
       },
      ], // 卡面列表
      acrdIndex: 0,
      activeCardTab: "card_0", // 当前激活的卡面tab
      activityDataID: 56,
      customFile: {},
      customTemplateList: [],
      params: {},
      valueRow: "",
      backgroundOpacity: false,
      showSelectActivity: false,
      isSave: true,
      isCopy: true,
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      cardIdCounter: 2,
      activityTimeValue: this.$getDate(30, 10),
      fromLoading: false, // 数据加载 显示
      joinBlackList: false,
      checked: false,
      isDraft: false,
      isBanShowGoods: false, // 是否禁止活动商品展示
      // informationForm组件所需参数
      activityStartTime: null, // 活动开始时间
      activityEndTime: null, // 活动结束时间
      peopleSelected: [], // 已选择的人群
      localStepNum: 0, // 当前步骤数
      // timeDay: 0,
      // timeOut: 0,
      ruleForm: {
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        skuList: [], // 商品列表
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        jumpUrl: "",
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
      },
      uploadSize: false, // 添加上传尺寸校验标识
      defaultTemplateImage:
        "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 默认模板图片
      activityMap: {
        16: "下单有礼",
        17: "首单专享礼",
        18: "复购有礼",
        36: "打榜有礼",
        46: "满额有礼",
      },
      unitList: [], // 计量单位列表-满额
      measureUnitId: "", // 单位id-满额
      // 新增发送人数和投放人群条件相关变量
      sendNum: '', // 发送人数
      autoEndActivity: false, // 勾选奖品发放完毕自动结束活动
      deliveryCrowdType: 1, // 投放人群类型：1-关联活动，2-自定义人群
      activityData: {}, // 活动数据对象
      activeValue: 0, // 活动值
      isShopConditionExpandedOne:false
    }
  },
  async created() {
     this.buriedPoint(1, "BI店铺礼包", "互动管理", "互动活动");
    // 先从路由参数获取数据并设置到activityData
    // if (this.$route.query.valueRow) {
    //   this.activityData = {
    //     id: Number(this.$route.query.valueRow) || 0,
    //     isCopy: Number(this.$route.query.isCopy) || 0
    //   };
    //   this.activeValue = Number(this.$route.query.activeValue) || 0;
    // }
    // console.log('当前玩法id---->', this.activityData.isCopy);
    // console.log('当前玩法id---->', this.activityData.id, this.activeValue,this.valueRow);
    await this.loadCustomTemplate(); // 加载自定义模板（等待加载完成，确保回显时能拿到模板ID）
   console.log(this.activityData.id,'55555555',this.valueRow);
   
    if (this.valueRow && this.activityData.id === 63) {
      console.log(14414444);
      await this.initTemplateData();
      
     
      this.activityDataID = 57;
      await this.getEdit();
  
      // 设置默认模板（只需要调用一次）
      await this.setDefaultTemplateForNewActivity();
      // this.ruleForm.defaultCardUrl =
      //   "https://cdn-image.yucrm.cn//hd/images/13315956_8656e64b784e4870a7d799e4d15cfaf5.png";
      // this.defaultTemplateImage =
      //   "https://cdn-image.yucrm.cn//hd/images/13315956_8656e64b784e4870a7d799e4d15cfaf5.png";
    } else {
        console.log(1499999999);
      // 非BI店铺礼包活动类型的初始化
      await this.initTemplateData();
      await this.setDefaultTemplateForNewActivity();
    }
   

    // // // 数据初始化
    // console.log("--- ~ this.$route.query:---", this.$route.query,this.isCopy);
    // if (this.$route.query.valueRow) {
    //   // 刷新的时候 false会从布尔值变成字符串 "false"
    //   this.backgroundOpacity =
    //     this.$route.query.backgroundOpacity === true ||
    //     this.$route.query.backgroundOpacity === "true";
    //   this.isSave =
    //     this.$route.query.isSave === true ||
    //     this.$route.query.isSave === "true";
    //   this.statusComment =
    //     this.$route.query.statusComment === true ||
    //     this.$route.query.statusComment === "true";
    //   this.isCopy = Number(this.$route.query.isCopy) || 0;
    //   this.activeValue = Number(this.$route.query.activeValue) || 0;
    //   this.type = Number(this.$route.query.type) || 0;
    //   this.valueRow = this.$route.query.valueRow;
    //   this.getEdit();
    // } else {
    //   await this.initTemplateData();
    //   await this.setDefaultTemplateForNewActivity();
    //   return; // 新建活动时直接返回，避免重复调用 initTemplateData
    // }
    // await this.initTemplateData();
  },
  mounted() {
    this.getmeasureUnitPage();
  },
  methods: {
    isChange(){
       this.isShowGoods = true
       //如果有sku的话回显
       if(this.cardFaces[this.acrdIndex].ruleForm.skuList){
          this.skuList = this.cardFaces[this.acrdIndex].ruleForm.skuList
       }
    },
    selectGoodsChange(data){
          // 无论data是否为空，都更新skuList，确保可以清空
          this.skuList = Array.isArray(data) ? [...data] : [];
          const currentCard = this.cardFaces[this.acrdIndex];
          if (currentCard) {
          // 确保ruleForm和ruleDTO对象存在
          if (!currentCard.ruleForm) {
            currentCard.ruleForm = {};
          }
          if (!currentCard.ruleForm.ruleDTO) {
            currentCard.ruleForm.ruleDTO = {};
          }
          // 更新当前卡面的skuList，确保是数组
          currentCard.ruleForm.skuList = Array.isArray(data) ? [...data] : [];
         }
        this.isShowGoods = false            
    },
    syncJumpLink(cardFace) {
       if (!cardFace.activityInfo) {
         cardFace.activityInfo = {};
       }
       cardFace.activityInfo.jumpLink = cardFace.jumpUrl;
     },
    //入会链接 - 为指定卡面设置入会链接
    setOpenUrl(cardFace) {
      // 确保cardFace对象存在
      if (!cardFace) return;
      
      try {
        // 获取商家ID
        let venderId = this.$store.getters.loginUserInfo.venderId;
        
        // 设置入会链接，只对当前点击的卡面生效
        let joinLink = `https://shopmember.m.jd.com/shopcard/?venderId=${venderId}&venderType=1&channel=80355979`;
        
        // 确保activityInfo对象存在
        if (!cardFace.activityInfo) {
          cardFace.activityInfo = {};
        }
        
        // 直接修改输入框绑定的属性，确保默认弹窗1也能正确赋值
        // 使用Vue.set确保响应式更新
        if (this.$set) {
          this.$set(cardFace, 'jumpUrl', joinLink);
        } else {
          // 降级方案
          cardFace.jumpUrl = joinLink;
        }
        
        // 同步更新相关属性，确保数据一致性
        cardFace.activityInfo.jumpUrl = joinLink;
        cardFace.activityInfo.jumpLink = joinLink;
        
        // 手动触发同步方法
        this.syncJumpLink(cardFace);
        
        // 强制更新DOM，确保输入框正确显示值
        this.$nextTick(() => {
          // DOM更新后的回调，确保视图更新
        });
      } catch (error) {
        console.error('设置入会链接失败:', error);
      }
     },
     selectPeopleSure(val) {
      // 获取当前激活的卡面，并将选中的人群ID存储到卡面的ruleForm.peopleSelected中
      // 查找当前激活的卡面，使用activeCardTab作为标识
      const currentCardFace = this.cardFaces.find(item => item.id === this.activeCardTab);
      if (currentCardFace && currentCardFace.ruleForm) {
        currentCardFace.ruleForm.peopleSelected = val.map(item => item.id)
      }
      this.selectPeopleShow = false
    },
    // 初始化模板数据
    async initTemplateData() {
      try {
        this.templateLoading = true;
        // 获取模板分组数据（tabs）
        const num = 3;
        const GiftBag = await getGiftBagList(num);
        console.log("--- ~ GiftBag:---", GiftBag);

        // 添加"全部"tab到第一位
        this.templateTabs = [
          {
            name: "全部",
            value: -1,
            id: -1,
          },
          ...GiftBag.data.map((item) => ({
            name: item.title,
            value: item.id,
            id: item.id,
          })),
        ];

        // 获取默认模板列表
        if (this.templateTabs.length > 0) {
          await this.getTemplateList(this.templateTabs[0].id); // 默认加载第一个tab的模板（全部）
        }
      } catch (error) {
        console.error("初始化模板数据失败:", error);
        this.$message.error("加载模板数据失败");
      } finally {
        this.templateLoading = false;
      }
    },

    // 获取模板列表
    // async getTemplateList(tabIndex, cardId = null) {
    async getTemplateList(id, cardId = null) {
      try {
        console.log("--- ~ this.templateCache:---", this.templateCache);
        // 检查缓存中是否已有该tab的数据
        if (this.templateCache.has(id)) {
          console.log("从缓存中获取模板数据:", id);
          this.templateList = this.templateCache.get(id);
          return;
        }

        this.templateLoading = true;
        let obj = {
          current: 1,
          size: 10000,
          giftType:3,
          // 初始不设置dirId，避免使用错误的this.templateTabs.id
          // source: this.activityDataID == 56 ? 7 : 8,
        };

        // 如果不是"全部"tab，设置dirId参数
        if (id !== -1) {
          obj.dirId = id;
        }

        const { data } = await getGiftBagTemplate(obj);
        const templateList = data.records || [];

        // 将数据存入缓存
        this.templateCache.set(id, templateList);
        this.templateList = templateList;

        console.log("从接口获取并缓存模板数据:", id, templateList);
      } catch (error) {
        console.error("获取模板列表失败:", error);
        this.$message.error("获取模板列表失败");
      } finally {
        this.templateLoading = false;
      }
    },
    // 处理发送人数输入，确保只能输入正整数
    handleSendNumInput() {
      // 过滤掉所有非数字字符
      this.sendNum = this.sendNum.replace(/[^0-9]/g, '');
      
      // 转换为数字并确保大于等于1
      if (this.sendNum && parseInt(this.sendNum) < 1) {
        this.sendNum = '1';
      }
    },
    
    // 添加卡面
    addCardFace() {
      // 兜底页不计入添加数量，所以实际可添加数量是20-1=19
      if (this.cardFaces.length>= 20) {
        this.$message.warning("最多只能添加20个弹窗");
        return;
      }
      
      // 获取当前tab对应的第一个系统模板，作为新弹窗的默认模板
      const firstTabId = this.templateTabs.length > 0 ? this.templateTabs[0].id : "";
      let defaultTemplateId = "";
      let defaultTemplateUrl = "";
      if (this.templateList && this.templateList.length > 0) {
        defaultTemplateId = this.templateList[0].id || "";
        defaultTemplateUrl = this.templateList[0].templateUrl || "";
      }

      const newCardFace = {
        id: `card_${this.cardIdCounter++}`,
        title: "",
        topic: "",
        description: "",
        isShowParticipateNum: 1,
        isShowActivityItem: 0,
        templateType: 0,
        templateId: defaultTemplateId, // 默认选中第一个系统模板
        imageUrl: defaultTemplateUrl, // 默认模板图片
        cusTemplateJSON: "",
        activeTabIndex: 0,
        activityInfo: {},
        activeTabId: firstTabId,
        popupTemplate: {
          templateId: defaultTemplateId,
          templateType: 0,
          templateUrl: defaultTemplateUrl,
          templateCategory: firstTabId
        },
        previewData: {},
        jumpUrl: "", // 跳转链接作为顶层属性
        ruleForm: {
        skuList:[],
        actMember:"1",
        //设置规则表单
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        activityName: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: '',   // 最小订单笔数
        orderCompleteMaxCount: '',     // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: '', // 最小订单金额
        orderCompleteMaxPayment: '',   // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: '',   // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: '',     // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: '',  // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: '',    // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        isOpenShoppingConditions:false,
        cartFullDays:1,
        defaultCardUrl:
          "https://cdn-image.yucrm.cn//hd/images/13315956_abc1a8d9c449448ebaab0dafdc0ac842.png", // 兜底卡面
        partner: ["-1"],
        peopleSelected: [], // 已选择的人群
        ruleDTO: {
          plusObject: 0, // plus会员
          cusType: 0, // 新老客类型
          isCheckOpenCardTime: false, // 是否检查开卡时间
          openCardStartTime: '', // 开卡开始时间
          openCardEndTime: '', // 开卡结束时间
          joinType: 0 // 参与方式
        }
      },
      };

      // 将新卡面添加到数组末尾（兜底页之前）
      // 兜底页是最后一个元素，所以在倒数第二个位置插入
      this.cardFaces.splice(this.cardFaces.length - 1, 0, newCardFace);
      // 设置新添加的卡面为激活状态
      this.activeCardTab = newCardFace.id;
      // 同步更新acrdIndex为新卡面的索引
      this.acrdIndex = this.cardFaces.length - 2;
      
      // 移除重置操作，避免覆盖新卡面数据
      
      if (this.templateTabs.length > 0) {
        const firstTabId = this.templateTabs[0].id;
        this.getTemplateList(firstTabId).then(() => {
          // 模板加载完成后，如果有模板则选中第一个
          if (this.templateList.length > 0) {
            // 获取新添加卡面的索引（在兜底页之前）
            const newCardIndex = this.cardFaces.length - 2;
            this.$set(this.cardFaces[newCardIndex], "templateId", this.templateList[0].id);
            this.$set(this.cardFaces[newCardIndex], "imageUrl", this.templateList[0].templateUrl);
            
            // 设置当前选中的模板ID
            this.selectedTemplateId = this.templateList[0].id;
            // 设置为系统模板类型
            this.$set(this.cardFaces[newCardIndex], "templateType", 0);
          }
        });
      }
    },
    
    // 重置用户条件参数
    // resetUserConditionParams() {
    //   // 重置投放人群类型
    //   // this.deliveryCrowdType = 1; // 默认1: 全部人群
    //   // 重置活动对象
    //   this.actMember = "1"; // 默认1: 全部身份
      
    //   // 重置规则表单中的用户条件参数
    //   // 新老客户类型
    //   this.ruleForm.ruleDTO.cusType = 0;
    //   // Plus会员身份
    //   this.ruleForm.ruleDTO.plusObject = 0;
    //   // 首次入会时间相关参数
    //   this.ruleForm.firstOpenCardTimeType = 0;
    //   this.ruleForm.openCardBeforeDay = "";
    //   // 开卡时间指定时间段参数
    //   this.ruleForm.ruleDTO.openCardStartTime = '';
    //   this.ruleForm.ruleDTO.openCardEndTime = '';
    //   // 是否检查开卡时间
    //   this.ruleForm.ruleDTO.isCheckOpenCardTime = false;
    //   // 购物条件 - 累计完成订单笔数
    //   this.ruleForm.orderCompleteLimitCount = '';
    //   this.ruleForm.orderCompleteMaxCount = '';
    //   // 购物条件 - 累计完成订单金额
    //   this.ruleForm.orderCompleteLimitPayment = '';
    //   this.ruleForm.orderCompleteMaxPayment = '';
    //   // 购物条件 - 最后一次订单完成时间
    //   this.ruleForm.lastOrderCompleteTimeType = 0;
    //   this.ruleForm.lastOrderCompleteStartDay = '';
    //   this.ruleForm.lastOrderCompleteEndDay = '';
    //   this.ruleForm.lastOrderCompleteStartTime = '';
    //   this.ruleForm.lastOrderCompleteEndTime = '';
    // },

    // 删除卡面
    removeCardFace(cardId) {
      if (this.backgroundOpacity) {
        return;
      }
      // 根据cardId找到对应的数组索引
      const index = this.cardFaces.findIndex((face) => face.id === cardId);
      // 不允许删除最后一个卡面（兜底页）
      if (index === this.cardFaces.length - 1) {
        this.$message.warning("默认兜底页不允许删除！");
        return;
      }
      // 确保删除后至少保留一个卡面和兜底页
      if (this.cardFaces.length <= 1) {
        this.$message.warning("请至少保留一个卡面和兜底页！");
        return;
      }
      if (index > -1) {
        this.cardFaces.splice(index, 1);
        // 如果删除的是当前激活的tab，切换到合适的tab
        if (this.activeCardTab == cardId && this.cardFaces.length > 0) {
          // 优先切换到兜底页
          const lastIndex = this.cardFaces.length - 1;
          this.activeCardTab = this.cardFaces[lastIndex].id;
        }
      }
    },

    // 选择活动
    selectActivity(index) {
      this.acrdIndex = index;
      this.showSelectActivity = true;
    },

    // 处理卡面切换事件
    async handleCardTabClick(tab) {
      console.log("切换到卡面:", tab.name, "ID:", tab.name);
      
      // 先保存当前卡面的ruleForm数据（如果存在）
      // if (this.activeCardTab && this.activeCardTab !== tab.name) {
      //   const previousCardFace = this.cardFaces.find(
      //     (face) => face.id === this.activeCardTab
      //   );
      //   if (previousCardFace && previousCardFace.ruleForm) {
      //     // 保存当前的用户条件参数到之前的卡面
      //     previousCardFace.ruleForm.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
      //     previousCardFace.ruleForm.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      //     previousCardFace.ruleForm.orderCompleteLimitCount = this.ruleForm.orderCompleteLimitCount;
      //     previousCardFace.ruleForm.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      //     previousCardFace.ruleForm.orderCompleteLimitPayment = this.ruleForm.orderCompleteLimitPayment;
      //     previousCardFace.ruleForm.orderCompleteMaxPayment = this.ruleForm.orderCompleteMaxPayment;
      //     previousCardFace.ruleForm.lastOrderCompleteTimeType = this.ruleForm.lastOrderCompleteTimeType;
      //     previousCardFace.ruleForm.lastOrderCompleteStartDay = this.ruleForm.lastOrderCompleteStartDay;
      //     previousCardFace.ruleForm.lastOrderCompleteEndDay = this.ruleForm.lastOrderCompleteEndDay;
      //     previousCardFace.ruleForm.lastOrderCompleteStartTime = this.ruleForm.lastOrderCompleteStartTime;
      //     previousCardFace.ruleForm.lastOrderCompleteEndTime = this.ruleForm.lastOrderCompleteEndTime;
          
      //     // 保存ruleDTO中的参数
      //     if (previousCardFace.ruleForm.ruleDTO && this.ruleForm.ruleDTO) {
      //       previousCardFace.ruleForm.ruleDTO.cusType = this.ruleForm.ruleDTO.cusType;
      //       previousCardFace.ruleForm.ruleDTO.plusObject = this.ruleForm.ruleDTO.plusObject;
      //       previousCardFace.ruleForm.ruleDTO.openCardStartTime = this.ruleForm.ruleDTO.openCardStartTime;
      //       previousCardFace.ruleForm.ruleDTO.openCardEndTime = this.ruleForm.ruleDTO.openCardEndTime;
      //       previousCardFace.ruleForm.ruleDTO.isCheckOpenCardTime = this.ruleForm.ruleDTO.isCheckOpenCardTime;
      //     }
      //   }
      // }
      
      // 找到当前激活的卡面
      const currentCardFace = this.cardFaces.find(
        (face) => face.id === tab.name
      );
      this.acrdIndex = this.cardFaces.indexOf(currentCardFace);
      
      // 移除重置操作，避免覆盖卡面数据
      // 从新卡面加载ruleForm数据（如果存在）
      if (currentCardFace && currentCardFace.ruleForm) {
        // 加载用户条件参数
        this.ruleForm.firstOpenCardTimeType = currentCardFace.ruleForm.firstOpenCardTimeType || 0;
        this.ruleForm.openCardBeforeDay = currentCardFace.ruleForm.openCardBeforeDay || "";
        this.ruleForm.orderCompleteLimitCount = currentCardFace.ruleForm.orderCompleteLimitCount || "";
        this.ruleForm.orderCompleteMaxCount = currentCardFace.ruleForm.orderCompleteMaxCount || "";
        this.ruleForm.orderCompleteLimitPayment = currentCardFace.ruleForm.orderCompleteLimitPayment;
        this.ruleForm.orderCompleteMaxPayment = currentCardFace.ruleForm.orderCompleteMaxPayment;
        this.ruleForm.lastOrderCompleteTimeType = currentCardFace.ruleForm.lastOrderCompleteTimeType || 0;
        this.ruleForm.lastOrderCompleteStartDay = currentCardFace.ruleForm.lastOrderCompleteStartDay || "";
        this.ruleForm.lastOrderCompleteEndDay = currentCardFace.ruleForm.lastOrderCompleteEndDay || "";
        this.ruleForm.lastOrderCompleteStartTime = currentCardFace.ruleForm.lastOrderCompleteStartTime || "";
        this.ruleForm.lastOrderCompleteEndTime = currentCardFace.ruleForm.lastOrderCompleteEndTime || "";
        // 加载partner属性，用于allowLevel回显
        this.ruleForm.partner = Array.isArray(currentCardFace.ruleForm.partner) ? [...currentCardFace.ruleForm.partner] : ["-1"];
        
        this.ruleForm.skuList = currentCardFace.ruleForm.skuList || [];
        console.log(this.ruleForm.skuList,'656565456564');
        
        



        
        // 加载关联人群参数，确保回显选中的人群
        // 加载actMember，确保回显活动对象类型
        this.actMember = currentCardFace.ruleForm.actMember || "1";
        if (Array.isArray(currentCardFace.ruleForm.peopleSelected)) {
          this.peopleList = currentCardFace.ruleForm.peopleSelected.map(id => ({ id }));
        } else {
          this.peopleList = [];
        }
        
        // 加载ruleDTO中的参数
        if (currentCardFace.ruleForm.ruleDTO && this.ruleForm.ruleDTO) {
          this.ruleForm.ruleDTO.cusType = currentCardFace.ruleForm.ruleDTO.cusType || 0;
          this.ruleForm.ruleDTO.plusObject = currentCardFace.ruleForm.ruleDTO.plusObject || 0;
          this.ruleForm.ruleDTO.openCardStartTime = currentCardFace.ruleForm.ruleDTO.openCardStartTime || "";
          this.ruleForm.ruleDTO.openCardEndTime = currentCardFace.ruleForm.ruleDTO.openCardEndTime || "";
          this.ruleForm.ruleDTO.isCheckOpenCardTime = currentCardFace.ruleForm.ruleDTO.isCheckOpenCardTime || false;
        }
      }
      if (currentCardFace && currentCardFace.activeTabId) {
        // 加载该卡面激活tab对应的模板列表
        await this.getTemplateList(currentCardFace.activeTabId);
        console.log(
          "已加载卡面模板列表，activeTabId:",
          currentCardFace.activeTabId
        );
      }
      // 修改活动的时候
      if (
        this.$route.query.valueRow &&
        this.cardFaces[this.acrdIndex].activityInfo.activityId
      ) {
        let row = {
          title: this.cardFaces[this.acrdIndex].title,
          topic: this.cardFaces[this.acrdIndex].topic,
          subType: 36,
          id: this.cardFaces[this.acrdIndex].activityInfo.activityId,
          ...this.cardFaces[this.acrdIndex].activityInfo,
        };
        console.log("--555- ~ row:---", row);
        this.handlerSelectActivity(row, true, "clickTab");
      }
    },

    // 处理tab点击事件
    async handleTabClick(id, tabIndex) {
      console.log("--- ~ id, tabIndex:---", id, tabIndex);
      const cardFace = this.cardFaces[tabIndex];
      console.log("--- ~ cardFace:---", cardFace);
      if (cardFace) {
        cardFace.activeTabId = id;
        const selectedTab = this.templateTabs.find((tab) => tab.id == id);
        console.log("选中的tab:", selectedTab, "for card index:");
        // 调用优化后的getTemplateList，会自动使用缓存
        await this.getTemplateList(id, tabIndex);
      }
    },
    // 选择模板
    selectTemplate(cardIndex, templateIndex, templateId, templateData) {
      const cardFace = this.cardFaces[cardIndex];
      if (cardFace) {
        this.$set(cardFace, "templateId", templateId);
        this.$set(cardFace, "cusTemplateJSON", "");
        this.$set(cardFace, "templateType", 0);
        // 使用templateUrl字段，因为接口已更新
        this.$set(cardFace, "imageUrl", templateData.templateUrl);
        // 设置popupTemplate
        this.$set(cardFace, "popupTemplate", {
          ...cardFace.popupTemplate,
          templateId: templateId,
          templateType: 0,
          templateUrl: templateData.templateUrl
        });
        console.log("选中模板:", templateData, "for card index:", cardIndex);
      }
    },

    // 选择自定义模板
    selectCustomTemplate(cardIndex, templateIndex, templateData) {
      const cardFace = this.cardFaces[cardIndex];
      if (cardFace) {
        // 自定义模板ID，优先取接口返回的真实ID
        const customTemplateId = templateData.id || templateData.templateId || "";
        // 使用imageUrl字段，与模板选择判断逻辑保持一致
        this.$set(cardFace, "cusTemplateJSON", templateData.imageUrl);
        this.$set(cardFace, "templateId", customTemplateId); // 设置自定义模板ID
        this.$set(cardFace, "imageUrl", templateData.imageUrl);
        // 设置模板类型为自定义模板
        this.$set(cardFace, "templateType", 1);
        
        // 确保popupTemplate对象完整，设置templateId
        this.$set(cardFace, "popupTemplate", {
          ...cardFace.popupTemplate,
          templateId: customTemplateId,
          templateType: 1,
          templateCategory: -1,
          templateUrl: templateData.imageUrl
        });
        
        // 设置选中状态
        this.selectedTemplateId = "";
        console.log(
          "选中自定义模板:",
          templateData,
          "for card index:",
          cardIndex
        );
        
        // 强制更新视图确保选中状态正确显示
        this.$forceUpdate();
      }
    },

    //活动时间驱动
    activityTimeChange(val) {
      if (this.backgroundOpacity) return;
      if (this.activityTimeValue[1]) {
        const invalidateDate = new Date(
          this.$store.getters.loginUserInfo.expiresIn
        ).valueOf();
        const end = new Date(this.activityTimeValue[1]).getTime();

        if (end > invalidateDate) {
          this.$message.warning("活动时间不可超过互动数据授权有效期！");
          this.activityTimeValue[1] = "";
          return;
        }
      }
    },
    // 回显
    getEdit() {
      // 添加空值检查，防止valueRow为undefined或null时调用.id属性出错
      if (!this.valueRow) {
        console.error("回显失败：缺少valueRow参数");
        return;
      }
      getBiStoreGiftDetail(this.valueRow.id || this.valueRow) // 兼容id可能直接在valueRow中的情况
        .then((res) => {
          if (res.code == 1 || res.code == 200) {
            try {
              const data = res.data;
              // 回显基本信息
              this.ruleForm.activityName = data.activityName || "";
              //是否重点活动  
              this.isKeyActivity = data.isKeyActivity || 0;
              this.placementPosition = data.placementPosition ? data.placementPosition.split(',') : ["SHOP"];

              
              // 回显活动时间
              if (data.startTime && data.endTime && !this.activityData.isCopy) {
                this.activityTimeValue = [data.startTime, data.endTime];
              }

              if (this.activityData.isCopy) {
                this.ruleForm.activityName += "复制";
              }

              if (this.activityData.isCopy) {
                this.activityTimeValue = [];
              }

              //发送人数回显 - 优化为使用可选链操作符安全访问
              this.sendNum =data.ruleDTO.sendCount  || 0;

              //勾选奖品是否对的
              this.autoEndActivity = data.ruleDTO.isOutClose || false;

              //投放人群
              this.deliveryCrowdType = data.ruleDTO.audienceType || 1;

          
              // 回显卡面配置
              if (
                data.ruleDTO && data.ruleDTO.popupList &&
                data.ruleDTO.popupList.length > 0
              ) {
                this.cardFaces = data.ruleDTO.popupList.map((item, index) => {
                  let cardFace = {
                    id: `card_${index}`,
                    activeTabId: item.popupTemplate.templateCategory || "",
                    title: item.title || "",
                    topic: item.topic || "",
                    templateType: item.popupTemplate.templateType || 0, // 提供默认值，确保类型正确
                    cusTemplateJSON: item.cusTemplateJSON,
                    templateId: item.popupTemplate.templateId || "",
                    activeTabIndex: 0,
                    templateList: [],
                    // 回显新增字段
                    popupType: item.popupType,
                    priority: item.priority || (index + 1),
                    
                    //回显活动对象
                    activityInfo: {
                      ...(item.activityInfo || {}),
                      activityId: item.relatedActivity && item.relatedActivity.activityId || "",
                      subType: item.relatedActivity && item.relatedActivity.subType || "",
                      subTypeStr: item.relatedActivity && item.relatedActivity.subTypeStr || "",
                      // 回显关联活动信息
                      activityName: item.relatedActivity && item.relatedActivity.activityName || "",
                      sellerLinkName: item.relatedActivity && item.relatedActivity.sellerLinkName || "",
                      startTime: item.relatedActivity && item.relatedActivity.startTime || null,
                      endTime: item.relatedActivity && item.relatedActivity.endTime || null,
                    },
                    // 初始化ruleForm对象，用于回显用户条件参数和关联人群
                    ruleForm: {
                      actMember: "1", // 默认活动对象为不限
                      ruleDTO: {},
                      // 回显关联人群参数
                      peopleSelected: item.peopleSelected || [],
                      // 初始化用户条件相关字段，确保回显时字段存在
                      firstOpenCardTimeType: 0,
                      openCardBeforeDay: "",
                      orderCompleteLimitCount: '',
                      orderCompleteMaxCount: '',
                      orderCompleteLimitPayment: '',
                      orderCompleteMaxPayment: '',
                      lastOrderCompleteTimeType: 0,
                      lastOrderCompleteStartDay: '',
                      lastOrderCompleteEndDay: '',
                      lastOrderCompleteStartTime: '',
                      lastOrderCompleteEndTime: ''
                    },
                    previewData: {
                      activityType: "",
                      title: "",
                      topic: "",
                      description: "",
                      logo: "",
                      orderCountType: "",
                      imgCount: "",
                      statisticType: "",
                      orderPaymentLimit: "",
                      rankType: "", // 名次规则 0-按排名 1-按阶梯
                      itemLimitCount: "",
                      filterType: 0, // 指定商品 0-全部, 1-指定, 2-排除
                      orderLimitCount: "",
                    },
                  };

                  // 确保popupTemplate对象存在
                  const popupTemplate = item.popupTemplate || {};
                  
                  // 自定义模板
                  if (popupTemplate.templateType == 1) {
                    const templateUrl = item.cusTemplateJSON || popupTemplate.templateUrl || "";
                    // 先保留接口返回的原始templateId作为兜底
                    const originTemplateId = popupTemplate.templateId || item.templateId || "";
                    cardFace.imageUrl = templateUrl;
                    // 确保cusTemplateJSON字段正确设置，这是控制选中状态的关键字段
                    cardFace.cusTemplateJSON = templateUrl;
                    // 确保模板数据结构完整，保留原始templateId
                    cardFace.popupTemplate = {
                      ...popupTemplate,
                      templateId: originTemplateId,
                      templateType: 1,
                      templateCategory: popupTemplate.templateCategory || -1,
                      templateUrl: templateUrl
                    };
                    
                    // 从已加载的自定义模板列表中，根据图片URL匹配获取真实的模板ID
                    const matchedTemplate = this.customTemplateList.find(t => t.imageUrl === templateUrl);
                    const realTemplateId = (matchedTemplate && matchedTemplate.id) || originTemplateId;
                    // 回显真实的模板ID（优先匹配列表中的ID，匹配不到用接口返回的原始ID）
                    cardFace.templateId = realTemplateId;
                    cardFace.popupTemplate.templateId = realTemplateId;
                    // 如果自定义模板不在customTemplateList中，则添加它，确保回显时能正确选中
                    if (!matchedTemplate) {
                      // 26-08-31 已删除的复制不回显
                      // const customTemplate = {
                      //   id: realTemplateId || `custom_${Date.now()}_${index}`, // 兜底使用临时ID
                      //   imageUrl: templateUrl
                      // };
                      // this.customTemplateList.push(customTemplate);
                      cardFace.imageUrl = ""; // 触发校验让用户重新选择模板
                    }
                  } else if (popupTemplate.templateUrl) {
                    // 从popupTemplate中获取模板图片
                    cardFace.imageUrl = popupTemplate.templateUrl;
                    // 确保模板数据结构完整
                    cardFace.popupTemplate = {
                      ...popupTemplate
                    };
                  }

                  // 回显用户条件参数到每个卡面的ruleForm中
                  if (item.cusType !== undefined) {
                    cardFace.ruleForm.actMember = "2"; // 指定身份
                    cardFace.ruleForm.ruleDTO = {
                      ...cardFace.ruleForm.ruleDTO,
                      cusType: item.cusType || 0,
                      plusObject: item.plusObject !== undefined ? item.plusObject : 0,
                      openCardStartTime: item.openCardStartTime || '',
                      openCardEndTime: item.openCardEndTime || '',
                      isCheckOpenCardTime: item.isCheckOpenCardTime || false
                    };

                    // 回显会员等级 - 将allowLevel字符串转换为partner数组
                    if (item.allowLevel && typeof item.allowLevel === 'string') {
                      cardFace.ruleForm.partner = item.allowLevel.split(',');
                    } else {
                      cardFace.ruleForm.partner = ['-1']; // 默认值：全部会员等级
                    }
                    
                    // 回显会员等级 - 将allowLevel字符串转换为partner数组
                    if (item.allowLevel && typeof item.allowLevel === 'string') {
                      cardFace.ruleForm.partner = item.allowLevel.split(',');
                    } else {
                      cardFace.ruleForm.partner = ['-1']; // 默认值：全部会员等级
                    }
                    
                    // 复制用户条件参数到卡面的ruleForm
                    cardFace.ruleForm.firstOpenCardTimeType = item.firstOpenCardTimeType || 0;
                    cardFace.ruleForm.openCardBeforeDay = item.openCardBeforeDay || "";
                    cardFace.ruleForm.orderCompleteLimitCount = item.orderCompleteLimitCount || '';
                    cardFace.ruleForm.orderCompleteMaxCount = item.orderCompleteMaxCount || '';
                    cardFace.ruleForm.orderCompleteLimitPayment = item.orderCompleteLimitPayment;
                    cardFace.ruleForm.orderCompleteMaxPayment = item.orderCompleteMaxPayment;
                    cardFace.ruleForm.lastOrderCompleteTimeType = item.lastOrderCompleteTimeType || 0;
                    cardFace.ruleForm.lastOrderCompleteStartDay = item.lastOrderCompleteStartDay || '';
                    cardFace.ruleForm.lastOrderCompleteEndDay = item.lastOrderCompleteEndDay || '';
                    cardFace.ruleForm.lastOrderCompleteStartTime = item.lastOrderCompleteStartTime || '';
                    cardFace.ruleForm.lastOrderCompleteEndTime = item.lastOrderCompleteEndTime || '';
                    // 回显加入购物车人群条件
                    cardFace.ruleForm.isOpenShoppingConditions = item.isOpenShoppingConditions || false;
                    cardFace.ruleForm.cartFullDays = item.cartFullDays || 1;
                    // 回显商品列表 - 将逗号分隔的字符串转换为对象数组
                    if ((item.skuList || item.cartGoods) && (typeof item.skuList === 'string' || typeof item.cartGoods === 'string')) {
                      // 优先使用cartGoods字段，如果没有则使用skuList字段
                      const skuIdsString = item.cartGoods || item.skuList;
                      cardFace.ruleForm.skuList = skuIdsString.split(',').map(skuId => ({ skuId }));
                      //调用接口
                      const arrayNum = []
                      let idNum ={
                        current: 1,
                        size: 0,
                        skuIds: []
                      }
                      cardFace.ruleForm.skuList.forEach((res)=>{
                          arrayNum.push(res.skuId)
                      })  
                       if (arrayNum) {
                           idNum.skuIds = arrayNum.join(",");
                           idNum.size = arrayNum.length;
                           this.isShopConditionExpandedOne = true
                       }
                       getSkuList(idNum).then((res) => {
                              if (res.code == 1) {
                                console.log('res.data.records',res.data.records);
                                
                                cardFace.ruleForm.skuList = res.data.records;
                                this.skuList = res.data.records;
                            }
                       });
                    } else {
                      cardFace.ruleForm.skuList = [];
                    }
                  }
                  
                  // 为每个弹窗回显独立的跳转链接
                  cardFace.jumpUrl = item.jumpLink || "";



                  // 如果是活动类型57，回显额外字段
                  if (this.activityDataID == 57) {
                    cardFace.description = item.description || "";
                    cardFace.isShowParticipateNum = item.isShowParticipateNum || 0;
                    cardFace.isShowActivityItem = item.isShowActivityItem || 0;
                  }
                  
                  // 安全解析模板JSON数据
                  let templateData = null;
                  try {
                    if (item.templateJson) {
                      templateData = JSON.parse(item.templateJson);
                    }
                  } catch (e) {
                    console.error("解析模板JSON失败:", e);
                  }
                  
                  console.log("--- ~ templateData:---", templateData);
                  if (templateData && templateData.templateGroupId) {
                    cardFace.activeTabId = templateData.templateGroupId;
                    cardFace.imageUrl = templateData.firstPictureUrl;
                  } else {
                    // 提供默认的模板分类，避免后续操作出错
                    cardFace.activeTabId = this.templateTabs.length > 0 ? this.templateTabs[0].id : -1;
                  }
                  
          
                  // 回显关联人群参数到卡面的ruleForm中
                  if (item.crowdIds) {
                    cardFace.ruleForm.actMember = "3"; // 指定人群
                    // 将逗号分隔的字符串转换为数组
                    cardFace.ruleForm.peopleSelected = Array.isArray(item.peopleSelected) ? 
                      item.peopleSelected : 
                      (item.crowdIds ? item.crowdIds.split(',') : []);
                  }
                  return cardFace;
                });
                console.log("--- ~ this.cardFaces:---", this.cardFaces);
                // 设置当前激活的卡面
              //   if (this.cardFaces.length > 0) {
              //     this.activeCardTab = this.cardFaces[0].id;
                  
              //     // 回显用户条件参数（自定义人群时）
              //     const firstCardFace = data.ruleDTO.popupList[0];
              //     const firstCardFaceInCardFaces = this.cardFaces[0];
                  
              //     // 检查是否存在关联人群参数
              //     if (firstCardFace && firstCardFace.peopleSelected && firstCardFace.peopleSelected.length > 0) {
              //       // 设置投放人群类型为自定义人群
              //       this.deliveryCrowdType = 2;
              //       // 设置活动对象为指定人群，保存到第一个卡面的ruleForm中
              //       if (firstCardFaceInCardFaces && firstCardFaceInCardFaces.ruleForm) {
              //         firstCardFaceInCardFaces.ruleForm.actMember = "3";
              //       }
              //     }
              //     // 检查是否存在指定身份参数
              //     else if (firstCardFace && firstCardFace.cusType !== undefined) {
              //       // 设置投放人群类型为自定义人群
              //       this.deliveryCrowdType = 2;
              //       // 设置活动对象为指定身份，保存到第一个卡面的ruleForm中
              //       if (firstCardFaceInCardFaces && firstCardFaceInCardFaces.ruleForm) {
              //         firstCardFaceInCardFaces.ruleForm.actMember = "2";
                    
              //       // 回显新老客户类型
              //       this.ruleForm.ruleDTO.cusType = firstCardFace.cusType || 0;
              //       // 回显Plus会员身份
              //       this.ruleForm.ruleDTO.plusObject = firstCardFace.plusObject || 0;
              //       // 回显首次入会时间相关参数
              //       this.ruleForm.firstOpenCardTimeType = firstCardFace.firstOpenCardTimeType || 0;
              //       this.ruleForm.openCardBeforeDay = firstCardFace.openCardBeforeDay || "";
              //       // 回显开卡时间指定时间段参数
              //       this.ruleForm.ruleDTO.openCardStartTime = firstCardFace.openCardStartTime || '';
              //       this.ruleForm.ruleDTO.openCardEndTime = firstCardFace.openCardEndTime || '';
              //       // 回显是否检查开卡时间
              //       this.ruleForm.ruleDTO.isCheckOpenCardTime = firstCardFace.isCheckOpenCardTime || false;
              //       // 回显购物条件 - 累计完成订单笔数
              //       this.ruleForm.orderCompleteLimitCount = firstCardFace.orderCompleteLimitCount || '';
              //       this.ruleForm.orderCompleteMaxCount = firstCardFace.orderCompleteMaxCount || '';
              //       // 回显购物条件 - 累计完成订单金额
              //       this.ruleForm.orderCompleteLimitPayment = firstCardFace.orderCompleteLimitPayment || '';
              //       this.ruleForm.orderCompleteMaxPayment = firstCardFace.orderCompleteMaxPayment || '';
              //       // 回显购物条件 - 最后一次订单完成时间
              //       this.ruleForm.lastOrderCompleteTimeType = firstCardFace.lastOrderCompleteTimeType || 0;
              //       this.ruleForm.lastOrderCompleteStartDay = firstCardFace.lastOrderCompleteStartDay || '';
              //       this.ruleForm.lastOrderCompleteEndDay = firstCardFace.lastOrderCompleteEndDay || '';
              //       this.ruleForm.lastOrderCompleteStartTime = firstCardFace.lastOrderCompleteStartTime || '';
              //       this.ruleForm.lastOrderCompleteEndTime = firstCardFace.lastOrderCompleteEndTime || '';
              //     }
              //   }
              // }
              // 加载模板列表（如果需要）
              if (this.cardFaces.length > 0) {
                this.getTemplateList(this.cardFaces[0].activeTabId);
              }
              let row = {
                title: this.cardFaces[0].title,
                topic: this.cardFaces[0].topic,
                id: this.cardFaces[0].activityInfo.activityId,
                ...this.cardFaces[0].activityInfo,
              };
              console.log("--- ~ row:---", row);
              this.handlerSelectActivity(row, true, "clickTab");
              console.log("回显数据完成:", {
                ruleForm: this.ruleForm,
                activityTimeValue: this.activityTimeValue,
                cardFaces: this.cardFaces,
              });
              this.activityTimeChange();
            }} catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        })
        .catch((error) => {
          console.log("--- ~ error:---", error);
        });
    },


    // 校验参数
    checkParams() {
      // if (!this.activityTimeValue[0] || !this.activityTimeValue[1]) {
      //   this.$message.error("请填写活动时间");
      //   return false;
      // }
      if (this.ruleForm.activityName) {
        if (this.ruleForm.activityName.length > 15) {
          // 字数不能大于15
          this.$message.warning("计划名称不能超过15个字");
          return false;
        }
      }
      // if (!this.activityName) {
      //   this.$message.error("请填写活动名称");
      //   return false;
      // }
      // if (!this.activityDesc) {
      //   this.$message.error("请填写活动描述");
      //   return false;
      // }
      // if (!this.activityRules) {
      //   this.$message.error("请填写活动规则");
      //   return false;
      // }
      
      // 校验人群选择
      if (this.deliveryCrowdType === 2) {
        // 检查每个非兜底页的卡面
        for (let i = 0; i < this.cardFaces.length - 1; i++) {
          const cardFace = this.cardFaces[i];

           //活动对象，如果是指定身份
          if (cardFace.ruleForm.firstOpenCardTimeType == 1) {
            // 开卡时间指定时间段
            if (!cardFace.ruleForm.openCardBeforeDay) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定时间段`);
              return false;
            }
          }
          if (cardFace.ruleForm.firstOpenCardTimeType == 2) {
            // 开卡时间指定日期
            if (!cardFace.ruleForm.ruleDTO.openCardStartTime) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定日期`);
              return false;
            }
            if (!cardFace.ruleForm.ruleDTO.openCardEndTime) {
              this.$message.error(`弹窗${i + 1}请填写开卡时间指定日期`);
              return false;
            }
          }
           
          //最后一次订单完成时间判断
          if (cardFace.ruleForm.lastOrderCompleteTimeType == 1) {
            // 最后一次订单完成时间指定时间段
            if (!cardFace.ruleForm.lastOrderCompleteStartDay) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定时间段`);
              return false;
            }
          }
          if (cardFace.ruleForm.lastOrderCompleteTimeType == 2) {
            // 最后一次订单完成时间指定日期
            if (!cardFace.ruleForm.lastOrderCompleteStartTime) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定日期`);
              return false;
            }
            if (!cardFace.ruleForm.lastOrderCompleteEndTime) {
              this.$message.error(`弹窗${i + 1}请填写最后一次订单完成时间指定日期`);
              return false;
            }
          }


          // 当活动对象为指定身份时，无需额外人群校验
          if (cardFace.ruleForm && cardFace.ruleForm.actMember === "3") {
            // 检查是否已选择人群
            if (!cardFace.ruleForm.peopleSelected || cardFace.ruleForm.peopleSelected.length === 0) {
              this.$message.error(`弹窗${i + 1}请选择人群`);
              return false;
            }
          }
          
          // 校验跳转链接是否已填写
          if (!cardFace.jumpUrl || cardFace.jumpUrl.trim() === '') {
            this.$message.error(`弹窗${i + 1}请填写跳转链接`);
            return false;
          }

         
          








        }
        
        // 校验兜底页的跳转链接
        const bottomCardFace = this.cardFaces[this.cardFaces.length - 1];
        if (!bottomCardFace.jumpUrl || bottomCardFace.jumpUrl.trim() === '') {
          this.$message.error('兜底弹窗请填写跳转链接');
          return false;
        }
      }
      
      // 校验弹窗模板
      for (let i = 0; i < this.cardFaces.length; i++) {
        const cardFace = this.cardFaces[i];
        const pageType = i === this.cardFaces.length - 1 ? '兜底弹窗' : `弹窗${i + 1}`;
        
        if (cardFace.templateType === 0) {
          // 系统模板：必须选择模板（templateId不能为空）
          if (!cardFace.templateId) {
            this.$message.error(`${pageType}请选择系统模板`);
            return false;
          }
        } else if (cardFace.templateType === 1) {
          // 自定义模板：必须上传图片或选择已有自定义模板（imageUrl和cusTemplateJSON不能为空）
          if (!cardFace.imageUrl || !cardFace.cusTemplateJSON) {
            this.$message.error(`${pageType}选择了自定义模板，请上传图片或选择已有模板`);
            return false;
          }
        }
      }
      if(this.placementPosition.length==0) {  
        this.$message.warning("请选择活动投放位置！");
        return false;
      }
      
      return true;
    },
    // 保存前校验
    preSave() {
      if (!this.checkParams()) {
        return;
      }

      this.setParams();

      // return;
      this.joinBlackList = true;
    },
    // 设置参数
    setParams() {
      console.log(this.ruleForm,'123123123123');
      
      try {
        //创建活动时传参过去
        this.params = {
          subType: this.activityDataID,
          activityName: this.ruleForm.activityName,
          allowLevel: "-1",
          startTime: this.activityTimeValue[0],
          endTime: this.activityTimeValue[1],
          ruleDTO: {
            //发送人数
            sendCount:this.sendNum,
            //是否勾选奖品
            isOutClose:this.autoEndActivity,
            //投放类型
            audienceType:this.deliveryCrowdType,

            defaultCardUrl: this.ruleForm.defaultCardUrl,

            // jumpUrl: this.ruleForm.jumpUrl,
          },
          //是否重点活动
          isKeyActivity: this.isKeyActivity,
          placementPosition: this.placementPosition.join(','),
        };
        
        // 当选择自定义人群且活动对象为指定身份时，添加相关参数
        //关联活动的参数设置
        this.params.ruleDTO.popupList = this.cardFaces.map(
          (item, index) => {
           console.log(item,'item');
           
            let itemObj = {
              popupType:item.popupType? item.popupType:item.title === '兜底页'?'2':'1',//正常页面和兜底页
              priority: index + 1, // 弹窗优先级
              activityId: item.activityInfo.activityId,
              sellerLinkId: item.activityInfo.sellerLinkId,
              title: item.title,
              topic: item.topic,
              templateType: item.templateType, // 0: 系统模板, 1: 自定义模板
              templateId: item.templateId, // 模板ID
              jumpLink: this.deliveryCrowdType == 1 && item.activityInfo && item.activityInfo.activityId && item.activityInfo.jumpLink ? 
                  item.activityInfo.jumpLink : (item.jumpUrl || ''), // 投放人群为关联活动时，优先使用关联活动的jumpLink
              //关联活动设置
              relatedActivity:{
                activityId: item.activityInfo.activityId,
                activityName: item.activityInfo.activityName,
                subType:item.activityInfo.subType,
                sellerLinkName:item.activityInfo.sellerLinkName,
                startTime:item.activityInfo.startTime,
                endTime:item.activityInfo.endTime,
            
              },
              //弹窗模板设置
              popupTemplate:{
                // 优先从popupTemplate取模板ID，兼容根级别的templateId（系统模板）
                templateId: (item.popupTemplate && item.popupTemplate.templateId) ? item.popupTemplate.templateId : (item.templateId || ''),
                templateType: item.templateType, // 0: 系统模板, 1: 自定义模板
                templateUrl: item.imageUrl || (item.popupTemplate && item.popupTemplate.templateUrl) || '', // 模板图片URL
                templateCategory: item.activeTabId, // 模板分类 - 使用当前选中的tab id
              },
            };
            // 活动对象 - 从ruleForm中获取并添加空值检查
            itemObj.activityTargetType = item.ruleForm && item.ruleForm.actMember !== undefined ? item.ruleForm.actMember : ''
            
            console.log('99999',item.popupType,item.title );
            
            if (item.title == '兜底页' || item.popupType == '2') {
                // 根据投放人群类型区分处理跳转链接
                if (this.deliveryCrowdType == 1 && item.activityInfo && item.activityInfo.activityId && item.activityInfo.jumpLink) {
                    // 投放人群为关联活动时，优先使用关联活动的jumpLink
                    itemObj.jumpLink = item.activityInfo.jumpLink;
                } else {
                    // 投放人群为自定义人群时，使用cardFace的jumpUrl和全局ruleForm的jumpUrl
                    itemObj.jumpLink = item.jumpUrl || this.ruleForm.jumpUrl || '';
                }
            }
            
            // 当选择自定义人群且活动对象为指定身份时，为每个卡面添加用户条件参数
            if (this.deliveryCrowdType == 2 && item.ruleForm && item.ruleForm.actMember == "2") {
              itemObj = {
                ...itemObj,
                // 新老客户类型
                cusType: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.cusType : 0,
                // Plus会员身份
                plusObject: item.ruleForm && item.ruleForm.ruleDTO && item.ruleForm.ruleDTO.plusObject !== undefined ? item.ruleForm.ruleDTO.plusObject : 0,
                // 首次入会时间相关参数
                firstOpenCardTimeType: item.ruleForm ? item.ruleForm.firstOpenCardTimeType : 0,
                openCardBeforeDay: item.ruleForm ? item.ruleForm.openCardBeforeDay : "",
                // 开卡时间指定时间段参数
                openCardStartTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.openCardStartTime : '',
                openCardEndTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.openCardEndTime : '',
                // 是否检查开卡时间
                isCheckOpenCardTime: item.ruleForm && item.ruleForm.ruleDTO ? item.ruleForm.ruleDTO.isCheckOpenCardTime : false,
                // 购物条件 - 累计完成订单笔数
                orderCompleteLimitCount: item.ruleForm ? item.ruleForm.orderCompleteLimitCount : '',
                orderCompleteMaxCount: item.ruleForm ? item.ruleForm.orderCompleteMaxCount : '',
                // 购物条件 - 累计完成订单金额
                orderCompleteLimitPayment: item.ruleForm ? item.ruleForm.orderCompleteLimitPayment : '',
                orderCompleteMaxPayment: item.ruleForm ? item.ruleForm.orderCompleteMaxPayment : '',
                // 购物条件 - 最后一次订单完成时间
                lastOrderCompleteTimeType: item.ruleForm ? item.ruleForm.lastOrderCompleteTimeType : 0,
                lastOrderCompleteStartDay: item.ruleForm ? item.ruleForm.lastOrderCompleteStartDay : '',
                lastOrderCompleteEndDay: item.ruleForm ? item.ruleForm.lastOrderCompleteEndDay : '',
                lastOrderCompleteStartTime: item.ruleForm ? item.ruleForm.lastOrderCompleteStartTime : '',
                lastOrderCompleteEndTime: item.ruleForm ? item.ruleForm.lastOrderCompleteEndTime : '',
                // 会员等级设置，确保partner存在且为数组，解决allowLevel回显问题
                allowLevel: item.ruleForm && Array.isArray(item.ruleForm.partner) && item.ruleForm.partner.length ? item.ruleForm.partner.join(",") : "", 
                // 加入购物车人群条件
                isOpenShoppingConditions: item.ruleForm ? item.ruleForm.isOpenShoppingConditions : false,
                cartFullDays: item.ruleForm ? item.ruleForm.cartFullDays : 1,
                // 商品列表
                cartGoods: item.ruleForm  && item.ruleForm.skuList && Array.isArray(item.ruleForm.skuList) ? [...item.ruleForm.skuList].map((i)=>i.skuId).join(',') : '',
              };
            }
            // 关联人群参数设置
            if (this.deliveryCrowdType == 2 && item.ruleForm && item.ruleForm.actMember == "3") {
              itemObj = {
                ...itemObj,
                // 关联人群
                // 将人群ID数组转换为逗号分隔的字符串格式
                crowdIds: item.ruleForm && item.ruleForm.peopleSelected && Array.isArray(item.ruleForm.peopleSelected) 
                  ? item.ruleForm.peopleSelected.join(',') 
                  : ''
              };
            }
            return itemObj;
          }
        );
        // 自定义人群参数设置
        // if (this.isCopy) {
        //     delete obj.id;
        //  }
        
        // 修改活动时传递id
        if (this.valueRow.id || this.valueRow) {
          // this.params.id = this.valueRow.id;
          if (this.activityData.isCopy) {
            delete this.valueRow.id
          } else {
            // this.params.pointActivityId = this.$route.query.valueRow;
            this.params.id = this.valueRow.id;
          }
        }
      } catch (error) {
        console.log("--- ~ error:---", error);
      }
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setParams(); // 调用setParams初始化参数
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setParams(); // 调用setParams初始化参数
          this.handleDialogCloseAnoth();
        });
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        // 草稿箱保存时设置状态为5
        if(this.isDraft){
          this.params.status = 5;
        }
        // 草稿箱编辑时添加活动id
        if(this.isDraftEdit && this.valueRow && this.valueRow.id){
          this.params.id = this.valueRow.id;
        }
        const apiMethod = this.valueRow && this.valueRow.id && !this.isDraftEdit ? editBiStoreGift : createBiStoreGift;
        apiMethod(this.params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            if(this.isDraft){
              this.$message.success("保存成功！");
              this.$emit("returnBack", true);
            } else {
              this.$message.success(res.message || "创建成功");
              this.$router.push({
                  path: "/interactiveMarketing/activityManagement",
                  query: {
                    sort: "gift"
                  }
                });
              this.$emit("saveEdit");
            }
          } else {
            this.$message.error(res.message);
          }
        });
        this.joinBlackList = false;
      } else {
        this.$message.info(this.isDraft ? "请先勾选明确活动规则后即可保存草稿" : "请勾选明确活动规则后即可创建");
        return;
      }
    },
    clickLocalStep() {
        this.$emit("returnBack");
        return;
    },
    handleSelectActivityClose() {
      this.showSelectActivity = false;
    },
    handlerSelectActivity(row, isCloseTip = false, type = "") {
       let venderId = this.$store.getters.loginUserInfo.venderId;
        let options = {
          activityId: row.id,
          venderId: venderId,
          activityType: row.subType,
          id: 111,
          index: 222,
          sellerLinkName: row.sellerLinkName,
          sellerLinkId: row.sellerLinkId
        };
        let pcParams = encodeURIComponent(
          Object.keys(options)
            .map((item) => `${item}=${options[item]}`)
            .join("&")
        );
      
        // 判断 同一个小部件计划中所选活动不能重复，请重新选择！
        let isExist = this.cardFaces.some((item) => {
        return item.activityInfo.activityId == row.id;
        });
        if (isExist && !isCloseTip) {
        this.$message.warning(
          "同一个BI店铺礼包中所选活动不能重复，请重新选择！"
        );
        return;
       }
      // this.cardFaces[this.acrdIndex].topic = "";
      // 将选择的活动数据设置到对应的卡面
      if (this.acrdIndex !== "" && this.cardFaces[this.acrdIndex]) {
       // 根据不同活动类型生成对应的链接
        let xcxUrl = this.$commonUrl();
        // 19：特定活动类型
        if (row.subType == 19) {
          var jumpLink = xcxUrl +
             `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`
        } 
        // 46：购买礼品类型
        else if (row.subType == 46) {
          var jumpLink = xcxUrl +
            `pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`
        }
        // 1：签到赢好礼
        else if (row.subType == 1) {
          var jumpLink = xcxUrl +
            `pages/interactTask/signPolite/signPolite.html%3F${pcParams}`
        }
        // 3：每日抢好礼
        else if (row.subType == 3) {
          var jumpLink = xcxUrl +
            `pages/interactTask/robGoodPresent/robGoodPresent.html%3F${pcParams}`;
        }
        // 4：关注店铺有礼
        else if (row.subType == 4) {
          var jumpLink = xcxUrl +
            `pages/interactTask/attentionShop/attentionShop.html%3F${pcParams}`;
        }
        // 5：邀请开卡有礼
        else if (row.subType == 5) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
        }
        // 6：邀请关注店铺
        else if (row.subType == 6) {
          var jumpLink = xcxUrl +
            `pages/interactTask/invite/invite.html%3F${pcParams}`;
        }
        // 7：完善信息有礼
        else if (row.subType == 7) {
          var jumpLink = xcxUrl +
            `pages/interactTask/perfect_information/perfect_information.html%3F${pcParams}`;
        }
        // 8：幸运抽奖
        else if (row.subType == 8) {
          var jumpLink = xcxUrl +
            `pages/interactPark/bigTurntable/bigTurntable.html%3F${pcParams}`
        }
        // 京获客1.2 下单复购首购
        else if (
          row.subType == 16 ||
          row.subType == 17 ||
          row.subType == 18
        ) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
        }
        // 19：下单抽奖
        else if (row.subType == 19) {
          var jumpLink = xcxUrl +
            `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`;
        }
        // 京获客1.3 评价有礼
        else if (row.subType == 20) {
          var jumpLink = xcxUrl +
            `pages/interactTask/evaluation_gift/evaluation_gift.html%3F${pcParams}`;
        }
        // 京获客1.3 裂变神券
        else if (row.subType == 21) {
          var jumpLink = xcxUrl +
            `pages/interactTask/groupCoupon/groupCoupon.html%3F${pcParams}`;
        }
        // 京获客1.3 红包雨
        else if (row.subType == 22) {
          var jumpLink = xcxUrl +
            `pages/interactTask/redPacketRain/redPacketRain.html%3F${pcParams}`;
        }
        // 京获客1.4 疯狂抓娃娃
        else if (row.subType == 23) {
          var jumpLink = xcxUrl +
            `pages/gameCore/catchDoll/catchDoll.html%3F${pcParams}`;
        }
        // 京获客1.4 欢乐娃娃机
        else if (row.subType == 24) {
          var jumpLink = xcxUrl +
            `pages/gameCore/seekDistinct/seekDistinct.html%3F${pcParams}`;
        }
        // 预售有礼
        else if (row.subType == 27) {
          var jumpLink = xcxUrl +
            `pages/interactTask/preGift/preGift.html%3F${pcParams}`;
        }
        // 预售抽奖
        else if (row.subType == 28) {
          var jumpLink = xcxUrl +
            `pages/interactTask/prePrize/prePrize.html%3F${pcParams}`;
        }
        // 超级裂变
        else if (row.subType == 31) {
          var jumpLink = xcxUrl +
            `pages/interactTask/superCoupon/superCoupon.html%3F${pcParams}`;
        }
        // 加购有礼
        else if (row.subType == 34) {
          var jumpLink = xcxUrl +
            `pages/interactTask/addCart/addCart.html%3F${pcParams}`;
        }
        else if (row.subType == 13) {
          var jumpLink = "http://index.yeionsms.com/yidongd/index.html";
        }
        else if (row.subType == 14) {
          var jumpLink = "http://yq-hd-rc.isvjcloud.com/shop.html";
        }
        else if (row.subType == 36) {
          var jumpLink = xcxUrl +
            `pages/interactTask/orderRisk/orderRisk.html%3F${pcParams}`;
        }
        else if (row.subType == 37) {
          // 珀莱雅的活动单独处理，后续可能所有活动统一处理
          let params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
          var jumpLink = xcxUrl +
            "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
            params1;
        }
        // 红包
        else if (row.subType == 38) {
          var jumpLink = xcxUrl +
            `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
        }
        // 生日有礼
        else if (row.subType == 39) {
          var jumpLink = xcxUrl +
            `pages/interactTask/birthGift/birthGift.html%3F${pcParams}`;
        }
        // 会员升级礼
        else if (row.subType == 44) {
          var jumpLink = xcxUrl +
            `pages/upgradeMember/upgradeMember.html%3F${pcParams}`;
        }
        // 晒单有礼
        else if (row.subType == 41) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
          var jumpLink = xcxUrl +
            `pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
        }
        // 积分锁权
        else if (row.subType == 45) {
          var jumpLink = xcxUrl +
            `pages/interactTask/newLockAuth/newLockAuth.html%3F${pcParams}`;
        }
        // 满额有礼
        else if (row.subType == 46) {
          var jumpLink = `${xcxUrl}pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`;
        }
        // 情书贺卡
        else if (row.subType == 50) {
          var jumpLink = `${xcxUrl}pages/loveLettersCards/loveLettersCards.html%3F${pcParams}`;
        }
        // 调查问卷
        else if (row.subType == 47) {
          var jumpLink = `${xcxUrl}pages/question/question.html%3F${pcParams}`;
        }
        // 定时开奖
        else if (row.subType == 48) {
          var jumpLink = `${xcxUrl}pages/timeOpenWin/timeOpenWin.html%3F${pcParams}`;
        }
        // 0元试用
        else if (row.subType == 51) {
          var jumpLink = `${xcxUrl}pages/onTrial/onTrial.html%3F${pcParams}`;
        }
        //试用回购礼
        else if (row.subType == 52) {
          var jumpLink = `${xcxUrl}pages_2/trialRepurchase/trialRepurchase.html%3F${pcParams}`
        }
        // 购物打卡
        else if (row.subType == 53) {
          var jumpLink = `${xcxUrl}pages/shopClock/shopClock.html%3F${pcParams}`
        }
        // 集卡有礼
        else if (row.subType == 62) {
          var jumpLink = `${xcxUrl}pages_2/collectCardsGifts/collectCardsGifts.html%3F${pcParams}`
        }
        // 默认返回值
        else {
          var jumpLink = '';
        }
     
        
      this.cardFaces[this.acrdIndex].activityInfo = {
          activityId: row.id,
          activityName: row.activityName,
          subTypeStr: row.subTypeStr,
          sellerLinkId: row.sellerLinkId,
          sellerLinkName: row.sellerLinkName,
          startTime: row.startTime,
          endTime: row.endTime,
          status: row.status,
          statusStr: row.statusStr,
          subType: row.subType,
          jumpLink: jumpLink // 添加jumpLink字段
        };
        // 强制更新视图
        this.$forceUpdate();
      }
      console.log(
        "--- ~  this.cardFaces[this.acrdIndex].activityInfo:---",
        this.cardFaces[this.acrdIndex].activityInfo
      );
      this.showSelectActivity = false;
      let Arr = [16, 17, 18];
      if (Arr.includes(row.subType)) {
        purchaseActivityDetail(row.id).then((res) => {
          console.log("--- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            try {
              let previewData = {
                activityType: row.subType,
                title: "",
                topic: "",
                description: "",
                logo: "",
                orderCountType: "",
                imgCount: "",
                isBanGoodsShow: false,
                statisticType: "",
                orderPaymentLimit: "",
                itemLimitCount: "",
                itemList: [],
                filterType: 0, // 指定商品 0-全部, 1-指定, 2-排除
                orderLimitCount: "",
              };
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                previewData.title = data.activityName;
                this.cardFaces[this.acrdIndex].topic =
                  this.activityMap[row.subType];
                previewData.title = data.activityName;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.prizeSettingType = data.ruleDTO.prizeSettingType; // 奖品规则 0-统一, 1-阶梯
              previewData.filterType = data.ruleDTO.filterType; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.itemList = data.ruleDTO.itemList; // 指定商品 0-全部, 1-指定, 2-排除
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              if (row.subType == 17) {
                // 首购专享礼没有阶梯
                previewData.prizeSettingType = 0;
              }
              previewData.orderCountType = data.ruleDTO.orderCountType; // 累计满还是单笔满
              previewData.statisticType = 0; // 单位元
              previewData.imgCount = data.pointActivityPrizeDTOList.length;
              try {
                previewData.logo = data.pointActivityPrizeDTOList[0]
                  ? data.pointActivityPrizeDTOList[0].logo
                  : "";
              } catch (error) {
                previewData.logo = "";
              }

              previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              previewData.prizeType =
                data.pointActivityPrizeDTOList[0].prizeType;
              previewData.orderPaymentLimit = data.ruleDTO.orderStartPayment; // 订单金额
              previewData.itemLimitCount = data.ruleDTO.orderStartCount || ""; // 商品件数
              if (row.subType == 17) {
              }
              if (data.ruleDTO.prizeSettingType == 1) {
                // 阶梯
                previewData.imgCount = 1;
                previewData.orderPaymentLimit =
                  data.pointActivityPrizeDTOList[0].orderAmtLimit; // 订单金额
                previewData.itemLimitCount =
                  data.pointActivityPrizeDTOList[0].itemTotalLimit; // 商品件数
                previewData.stepList = data.pointActivityPrizeDTOList.map(
                  (item) => {
                    return {
                      orderPaymentLimit: item.orderAmtLimit,
                    };
                  }
                );
              }
              this.cardFaces[this.acrdIndex].previewData = previewData;
              
              // 将关联活动的链接设置到兜底页的跳转链接输入框
              // 尝试从活动详情中获取链接，如果没有则构造一个默认链接
              let activityUrl = data.activityUrl || `https://pro.m.jd.com/mall/active/${row.id}/index.html`;
              this.ruleForm.jumpUrl = activityUrl;
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
        // 打榜有礼 复购
      } else if (row.subType == 36) {
        orderRankDetail(row.id).then((res) => {
          console.log("--- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            try {
              let previewData = {
                activityType: row.subType,
                title: "",
                topic: "",
                description: "",
                logo: "",
                orderCountType: "",
                imgCount: "",
                statisticType: "",
                orderPaymentLimit: "",
                isBanGoodsShow: false,
                rankType: "", // 名次规则 0-按排名 1-按阶梯
                itemList: [],
                itemLimitCount: "",
                filterType: 0, // 指定商品 0-全部, 1-指定, 2-排除
                orderLimitCount: "",
              };
              // 小部件标题默认拿取活动名称
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                previewData.title = data.activityName;
                this.cardFaces[this.acrdIndex].topic =
                  this.activityMap[row.subType];
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.prizeSettingType = 1; // 奖品规则 0-统一, 1-阶梯
              previewData.filterType = data.ruleDTO.skuType; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.itemList = data.ruleDTO.itemList; // 指定商品 0-全部, 1-指定, 2-排除
              previewData.orderCountType = data.ruleDTO.orderCountType; // 累计满还是单笔满
              previewData.rankType = data.ruleDTO.rankType; // 名次规则 0-排名,1-阶梯
              previewData.imgCount = 1;
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              try {
                previewData.logo = data.prizeDTOList[0]
                  ? data.prizeDTOList[0].pointActivityPrizeDTOList[0].logo
                  : "";
              } catch (error) {
                previewData.logo = "";
              }
              try {
                previewData.prizeName =
                  data.prizeDTOList[0].pointActivityPrizeDTOList[0].title;
              } catch (error) {
                previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              }
              try {
                previewData.prizeType =
                  data.prizeDTOList[0].pointActivityPrizeDTOList[0].prizeType;
              } catch (error) {
                previewData.prizeType =
                  data.pointActivityPrizeDTOList[0].prizeType;
              }
              try {
                previewData.stepList = data.prizeDTOList.map((item) => {
                  return {
                    orderPaymentLimit:
                      item.pointActivityPrizeDTOList[0].totalAmount,
                  };
                });
              } catch (error) {
                previewData.stepList = data.pointActivityPrizeDTOList.map(
                  (item) => {
                    return {
                      orderPaymentLimit: item.totalAmount,
                    };
                  }
                );
              }
              if (previewData.rankType == 0) {
                previewData.imgCount =
                  data.prizeDTOList[0].pointActivityPrizeDTOList.length;
              }
              this.cardFaces[this.acrdIndex].previewData = previewData;
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
        // 满额
      } else if (row.subType == 46) {
        fullGiftDetail(row.id).then((res) => {
          console.log("-满额详情-- ~ res:---", res);
          let data = res.data;
          if (res.code == 1 || res.code == 200) {
            // statisticType: 0满额, 1满件, 3满笔, 2满额且满件
            // orderPaymentLimit 满额
            // itemLimitCount 满件
            // orderLimitCount 满笔
            let previewData = {
              activityType: row.subType,
              title: "",
              topic: "",
              description: "",
              logo: "",
              imgCount: "",
              isBanGoodsShow: false,
              statisticType: "",
              orderPaymentLimit: "",
              orderType: "",
              itemLimitCount: "",
              itemList: [],
              orderLimitCount: "",
              measureUnitLimitCount: "", // 自定义计量单位的消费门槛
            };
            try {
              // 小部件标题默认拿取活动名称
              if (type == "clickTab") {
                // 点击卡面时不改变title和topic和description
                previewData.title = this.cardFaces[this.acrdIndex].title;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                previewData.description =
                  this.cardFaces[this.acrdIndex].description;
              } else {
                // 小部件标题默认拿取活动名称
                this.cardFaces[this.acrdIndex].title = data.activityName;
                this.cardFaces[this.acrdIndex].topic = JSON.parse(
                  data.ruleDTO.customerPaperwork
                ).title;
                previewData.title = data.activityName;
                previewData.topic = this.cardFaces[this.acrdIndex].topic;
                this.cardFaces[this.acrdIndex].description =
                  JSON.parse(data.ruleDTO.customerPaperwork).desc ||
                  "数量有限，先到先得";
              }
              previewData.description =
                this.cardFaces[this.acrdIndex].description;
              previewData.isShowParticipateNum =
                this.cardFaces[this.acrdIndex].isShowParticipateNum;
              previewData.statisticType = data.ruleDTO.statisticType;
              previewData.prizeSettingType = data.ruleDTO.prizeSettingType; // 奖品规则 0-统一, 1-阶梯
              previewData.orderType = data.ruleDTO.orderType; // 0-订单付款, 1-订单完成
              previewData.orderCountType = data.ruleDTO.orderCountType; // 1累计满 2单笔满
              previewData.filterType = data.ruleDTO.filterType; // 0全部 1指定商品 2排除商品
              previewData.orderPaymentLimit = data.ruleDTO.orderPaymentLimit;
              previewData.itemLimitCount = data.ruleDTO.itemLimitCount;
              previewData.orderLimitCount = data.ruleDTO.orderLimitCount;
              previewData.imgCount = data.pointActivityPrizeDTOList.length;
              this.measureUnitId = data.ruleDTO.measureUnitId;
              previewData.measureUnitLimitCount =
                data.ruleDTO.measureUnitLimitCount;
              previewData.logo = data.pointActivityPrizeDTOList[0].logo;
              previewData.prizeName = data.pointActivityPrizeDTOList[0].title;
              previewData.prizeType =
                data.pointActivityPrizeDTOList[0].prizeType;
              this.cardFaces[this.acrdIndex].previewData = previewData;
              if (this.cardFaces[this.acrdIndex].isShowActivityItem == 1) {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = false;
                }
              } else {
                if (
                  previewData.filterType == 1 ||
                  previewData.filterType == 2
                ) {
                  previewData.isBanGoodsShow = true;
                }
              }
              if (data.ruleDTO.prizeSettingType == 1) {
                this.cardFaces[this.acrdIndex].previewData.stepList =
                  data.ruleDTO.stepList;
                // 取pointActivityPrizeDTOList里面 taskIndex == 1的数据个数
                previewData.imgCount = data.pointActivityPrizeDTOList.filter(
                  (item) => item.taskIndex === 1
                ).length;
                previewData.orderPaymentLimit =
                  data.ruleDTO.stepList[0].orderPaymentLimit;
                previewData.itemLimitCount =
                  data.ruleDTO.stepList[0].itemLimitCount;
                previewData.measureUnitLimitCount =
                  data.ruleDTO.stepList[0].measureUnitLimitCount;
              }
              if (data.ruleDTO.sellerSkuList[0]) {
                let skuIdList = data.ruleDTO.sellerSkuList[0].skuIds;
                console.log("--- ~ skuIdList:---", skuIdList);
                let params = {
                  current: 1,
                  size: 5,
                  categoryId: "",
                  skuIds: "",
                  wareStatus: "",
                  wareIdStr: "",
                  venderId: 13315956,
                };
                if (skuIdList) {
                  params.skuIds = skuIdList.join(",");
                }
                getSkuList(params).then((res) => {
                  console.log("--- ~ res:---", res);
                  if (res.code == 1) {
                    previewData.itemList = res.data.records;
                    console.log(
                      "--- ~ previewData.itemList:---",
                      previewData.itemList
                    );
                  }
                });
              }
              console.log("--- ~ previewData:---", previewData);
            } catch (error) {
              console.log("--- ~ error:---", error);
            }
          }
        });
      }
    },
    updatePreviewData(index, type) {
      let previewData = this.cardFaces[index].previewData;
      previewData.title = this.cardFaces[index].title;
      previewData.topic = this.cardFaces[index].topic;
      previewData.description = this.cardFaces[index].description;
      previewData.isShowParticipateNum =
        this.cardFaces[index].isShowParticipateNum;
      if (this.cardFaces[index].isShowActivityItem == 1) {
        if (previewData.filterType == 1 || previewData.filterType == 2) {
          previewData.isBanGoodsShow = false;
        }
      } else {
        if (previewData.filterType == 1 || previewData.filterType == 2) {
          previewData.isBanGoodsShow = true;
        }
      }
    },
    onBeforeUpload(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 630;
        let height = 788;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          if (this.activityDataID == 56) {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          } else {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          }
          return Promise.reject();
        }
      );
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];
      const isType = sorts.includes(type);
      // if (!isLt1M) {
      //   this.$message.info("上传图片大小不能超过 1MB");
      // }
      if (!isType) {
        if (this.activityDataID == 56) {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        } else {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        }
      }
      // return isLt1M && isType && isSize;
      return isType && isSize;
    },
    onBeforeUpload2(file) {
      this.customFile.imageName = file.name;
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 630;
        let height = 788;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          if (this.activityDataID == 56) {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          } else {
            this.$message.info(
              "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
            );
          }

          return Promise.reject();
        }
      );
      // 校验尺寸和类型
      const isLt1M = file.size < 1024 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".gif"];
      const isType = sorts.includes(type);
      // if (!isLt1M) {
      //   this.$message.info("上传图片大小不能超过 1MB");
      // }
      if (!isType) {
        if (this.activityDataID == 56) {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        } else {
          this.$message.info(
            "图片需满足 格式：jpg、png、gif，尺寸：宽630px * 高788px，请重新选择上传"
          );
        }
      }
      // return isLt1M && isType && isSize;
      return isType && isSize;
    },
    async onUploadSuccess2(res, cardIndex) {
      if (res.code != 1) {
        this.$message.error(res.message || "上传失败");
        return;
      }
      const uploadedImageUrl = res.data;
      // 更新对应卡面的自定义模板图片（先设置图片，后续再补ID）
      if (this.cardFaces[cardIndex]) {
        this.$set(this.cardFaces[cardIndex], "cusTemplateJSON", uploadedImageUrl);
        this.$set(this.cardFaces[cardIndex], "templateId", "");
        this.$set(this.cardFaces[cardIndex], "imageUrl", uploadedImageUrl);
        this.$set(this.cardFaces[cardIndex], "templateType", 1);
        // 初始化popupTemplate
        this.$set(this.cardFaces[cardIndex], "popupTemplate", {
          templateId: "",
          templateType: 1,
          templateCategory: -1,
          templateUrl: uploadedImageUrl
        });
      }
      let form = {
        imageUrl: uploadedImageUrl,
        imageName: this.customFile.imageName,
        type: 2,
        source: 9,
      };
      const addRes = await addImage(form);
      if (addRes && addRes.code == 1) {
        this.$message.success(addRes.message || "上传成功");
        // 重新加载自定义模板列表，通过URL匹配获取新上传图片的真实ID
        await this.loadCustomTemplate();
        const cardFace = this.cardFaces[cardIndex];
        if (cardFace) {
          // 根据图片URL匹配新上传的模板ID
          const newTemplate = this.customTemplateList.find(t => t.imageUrl === uploadedImageUrl);
          if (newTemplate) {
            const newTemplateId = newTemplate.id || newTemplate.templateId || "";
            this.$set(cardFace, "templateId", newTemplateId);
            this.$set(cardFace.popupTemplate, "templateId", newTemplateId);
          }
        }
        this.$forceUpdate();
      }
    },
    // 上传成功
    onUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      // 更新模板图片
      this.ruleForm.defaultCardUrl = res.data;
      this.uploadSize = true;
      // 强制更新视图
      this.$forceUpdate();
      this.$message.success("上传成功");
    },

    // 重置模板图片
    onTemplateReset() {
      this.ruleForm.defaultCardUrl = this.defaultTemplateImage;
      this.uploadSize = false;
      this.$forceUpdate();
      this.$message.success("重置成功");
    },
    async setDefaultTemplateForNewActivity() {
      try {
        // 确保有模板tabs和卡面
        if (this.templateTabs.length > 0 && this.cardFaces.length > 0) {
          const firstTabId = this.templateTabs[0].id;
          
          // 设置第一个卡面为系统模板
          const firstCardFace = this.cardFaces[0];
          firstCardFace.templateType = 0;
          firstCardFace.activeTabId = firstTabId;
          
          // 设置最后一个卡面（兜底页）为系统模板
          const lastCardFace = this.cardFaces[this.cardFaces.length - 1];
          lastCardFace.templateType = 0;
          lastCardFace.activeTabId = firstTabId;
          
          // 获取第一个tab的模板列表
          await this.getTemplateList(firstTabId);
          
          // 为两个卡面都设置第一个模板
          if (this.templateList.length > 0) {
            const firstTemplate = this.templateList[0];
            // 设置第一个卡面的模板
            this.$set(firstCardFace, "templateId", firstTemplate.id);
            this.$set(firstCardFace, "imageUrl", firstTemplate.templateUrl);
            
            // 设置最后一个卡面（兜底页）的模板
            this.$set(lastCardFace, "templateId", firstTemplate.id);
            this.$set(lastCardFace, "imageUrl", firstTemplate.templateUrl);
            
            // 设置当前选中的模板ID
            this.selectedTemplateId = firstTemplate.id;
          }
          
          console.log("--- 卡面1:---", firstCardFace);
          console.log("--- 兜底页:---", lastCardFace);
        }
      } catch (error) {
        console.error("设置默认模板失败:", error);
      }
    },
    // 处理模板类型改变事件
    async handleTemplateTypeChange(cardIndex, value) {
      const cardFace = this.cardFaces[cardIndex];
      if (!cardFace) return;
      
      if (value == 0) {
        // 切换到系统模板：清空自定义模板数据，设置默认系统模板
        const firstTabId = this.templateTabs.length > 0 ? this.templateTabs[0].id : "";
        let defaultTemplateId = "";
        let defaultTemplateUrl = "";
        if (this.templateList && this.templateList.length > 0) {
          defaultTemplateId = this.templateList[0].id || "";
          defaultTemplateUrl = this.templateList[0].templateUrl || "";
        }
        this.$set(cardFace, "templateType", 0);
        this.$set(cardFace, "templateId", defaultTemplateId);
        this.$set(cardFace, "cusTemplateJSON", "");
        this.$set(cardFace, "imageUrl", defaultTemplateUrl);
        this.$set(cardFace, "activeTabId", firstTabId);
        this.$set(cardFace, "popupTemplate", {
          templateId: defaultTemplateId,
          templateType: 0,
          templateUrl: defaultTemplateUrl,
          templateCategory: firstTabId
        });
      } else if (value == 1) {
        // 切换到自定义模板：清空系统模板数据，需要用户上传或选择已有模板
        this.$set(cardFace, "templateType", 1);
        this.$set(cardFace, "templateId", "");
        this.$set(cardFace, "cusTemplateJSON", "");
        this.$set(cardFace, "imageUrl", "");
        this.$set(cardFace, "popupTemplate", {
          templateId: "",
          templateType: 1,
          templateUrl: "",
          templateCategory: -1
        });
        // 确保自定义模板列表已加载
        if (!this.customTemplateList || this.customTemplateList.length === 0) {
          await this.loadCustomTemplate();
        }
      }
    },
    async loadCustomTemplate() {
      const { data } = await sellerImage({
        type:2,
        source: 9,
        current: 1,
        size: 10000,
      });
      this.customTemplateList = data.records || [];
    },
    deleteCustomTemplate(id) {
      // 先找到要删除的模板的imageUrl，用于检查卡面是否在使用
      const templateToDelete = this.customTemplateList.find(t => t.id == id);
      const deletedImageUrl = templateToDelete ? templateToDelete.imageUrl : "";
      
      // 删除模板
      delImage(id).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message || "删除成功");
          this.loadCustomTemplate();
          
          // 检查所有卡面，如果有卡面正在使用被删除的模板，则清空数据
          if (deletedImageUrl) {
            this.cardFaces.forEach((cardFace) => {
              if (cardFace.templateType === 1 && cardFace.cusTemplateJSON === deletedImageUrl) {
                // 该卡面正在使用被删除的模板，清空数据，强制用户重新选择
                this.$set(cardFace, "templateId", "");
                this.$set(cardFace, "cusTemplateJSON", "");
                this.$set(cardFace, "imageUrl", "");
                this.$set(cardFace, "popupTemplate", {
                  templateId: "",
                  templateType: 1,
                  templateUrl: "",
                  templateCategory: -1
                });
              }
            });
          }
        }
      });
    },
    getmeasureUnitPage() {
      let data = {
        venderId: this.venderId, // 商家ID，需要从store或其他地方获取
        size: 9999,
        current: 1,
      };
      measureUnitPage(data).then((res) => {
        if (res.code == 1) {
          const list = res.data.records || [];
          this.unitList = list.filter((v) => v.status == 1);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  color: #333;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  height: 100%;

  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 40px 0 20px;
    height: calc(100% - 130px);
    overflow-y: auto;

    .lastTime {
      margin-left: 20px;
      font-size: 14px;

      i {
        color: #ccc;
      }
    }
  }
}

/* 卡面tabs样式 */
.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 15px;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  margin-right: 5px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
}

/* 模板容器样式 */
.template-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 650px;
  margin-top: 10px;
}

.template-item {
  width: 100px;
  // height: 200px;
  // overflow: hidden;
  margin-right: 15px;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
  border-radius: 2px;

  .template-item-wrapper {
    position: relative;

    &:hover .delectIcom {
      display: block;
    }
  }

  .delectIcom {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    display: none;
    z-index: 10;

    &:hover {
      opacity: 0.8;
    }
  }
}

.template-image {
  width: 100%;
  height: auto;
}

.template-name {
  width: 100%;
  overflow: hidden;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 2px;
  bottom: 10px;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.template-selected-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 15px;
  height: 15px;
}

.cardSet {
  display: flex;
  gap: 20px;
  position: relative;
  background-color: #fafafa;
  padding: 20px 0;
  margin: 0 0 10px 0;
  width: 1260px;
  // // 小屏时
  // @media screen and (max-width: 1400px) {
  //   width: 85%;
  // }
  // @media screen and (max-width: 1200px) {
  //   width: 100%;
  // }

  .preview-image-wrapper {
    width: 235px;
    height: 500px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    position: absolute;
    top: 0px;
    left: 1270px;
    background-color: #666;

    .preview-image {
      // width: 100%;
      // height: 100%;
      // object-fit: cover;

    width: 90%;
    /* height: 100%; */
    -o-object-fit: cover;
    object-fit: cover;
    line-height: 100px;
    margin-top: 110px;
    margin-left: 11px;

    }
  }

  .form-content {
    flex: 1;
  }
}

.activityDetail {
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  span {
    line-height: 16px;
    margin: 4px 0;
  }
}

.template-tabs {
  display: flex;
  margin-top: 10px;
}

.tab-item {
  padding: 4px 12px;
  border: 1px solid #dcdfe6;
  line-height: 16px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s;
  margin-left: -1px;
  position: relative;
}

.tab-item.first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-left: 0;
}

.tab-item.last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.tab-item:hover {
  color: #3159ff;
  border-color: #3159ff;
  z-index: 1;
}

.tab-item.active {
  color: #3159ff;
  border-color: #3159ff;
  background-color: #f0f7ff;
  z-index: 2;
}

.ml10 {
  margin-left: 10px;
}

.c_666 {
  color: #666;
}

.c_999 {
  color: #999;
}

/deep/ .el-tabs__nav-prev {
  bottom: 0px !important;
}

/deep/ .el-tabs__nav-next {
  bottom: 0px !important;
}

/deep/ .el-tabs__content {
  overflow: visible;
}

.upload-template {
  margin-bottom: 12px;
  .upload-actions {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .template-preview {
    display: flex;
    align-items: flex-start;
    margin-top: 15px;

    .template-image {
      width: 160px;
      height: 76px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
      margin-right: 15px;
    }

    .image-slot {
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 30px;
        color: #909399;
      }
    }

    .upload-tips {
      line-height: 1.8;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.c_999 {
  color: #999;
}


.previewTip {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  text-align: center;
}

.previewBg {
  position: absolute;
  top: 170px;
  left: 5px;
  width: 96%;
  height: 112px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}

.previewBg2 {
  position: absolute;
  top: 170px;
  left: 5px;
  height: 223px;
  width: 96%;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}
.condition-title {
  font-weight: 600;
  color: #000;
}
.toggle-btn {
  margin-left: 8px;
}
.cart-add-goods{
  margin-top: 12px;
}
</style>


